const HR_SCRIPT = `const GRADES={JM1:'Sales Executive',JM2:'Sr. Sales Executive',JM3:'Area Sales Manager',JM4:'Regional Sales Manager',JM5:'National Sales Manager',SM:'Senior Management'};
const GRADE_CLASS={JM1:'bg-jm1',JM2:'bg-jm2',JM3:'bg-jm3',JM4:'bg-jm4',JM5:'bg-jm5',SM:'bg-sm'};
const MONTHS=['January','February','March','April','May','June','July','August','September','October','November','December'];
const DS=['Su','Mo','Tu','We','Th','Fr','Sa'];
const ST={
  P:{l:'Present',c:'#166534',bg:'#dcfce7',bc:'#86efac'},
  A:{l:'Absent (LOP)',c:'#991b1b',bg:'#fee2e2',bc:'#fca5a5'},
  HD:{l:'Half Day',c:'#9a3412',bg:'#ffedd5',bc:'#fdba74'},
  H:{l:'Holiday',c:'#5b21b6',bg:'#ede9fe',bc:'#c4b5fd'},
  WO:{l:'Week Off',c:'#475569',bg:'#f1f5f9',bc:'#cbd5e1'},
  CL:{l:'Casual Leave',c:'#1e40af',bg:'#dbeafe',bc:'#93c5fd'},
  SL:{l:'Sick Leave',c:'#854d0e',bg:'#fef9c3',bc:'#fde047'},
  EL:{l:'Earned Leave',c:'#065f46',bg:'#ccfbf1',bc:'#5eead4'},
};
const SC=['P','A','HD','H','WO','CL','SL','EL'];
const VISIT_DAYS=['P','HD']; // Only these statuses allow visit count entry

const SAMPLE_EMPS=[
  {id:'EMP001',name:'Rajesh Jain',grade:'JM1',ctc:50000,ta:1600,special:'',mobile:399,pfRate:0,esicApplicable:false,visitTarget:12,revTarget:300000,newStoresTarget:5,territory:'Gujarat',doj:'2024-04-01',pan:'ABCPJ1234K',uan:'100234567890',bank:'HDFC Bank',account:'50200012345',ifsc:'HDFC0001234',phone:'9876543210',email:'rajesh@happyhands.co.in'},
  {id:'EMP002',name:'Vijay Kathad',grade:'JM2',ctc:27000,ta:1600,special:'',mobile:399,pfRate:0,esicApplicable:false,visitTarget:12,revTarget:150000,newStoresTarget:3,territory:'Saurashtra',doj:'2024-06-01',pan:'ABCPK5678L',uan:'100234567891',bank:'SBI',account:'32012345678',ifsc:'SBIN0001234',phone:'9765432109',email:'vijay@happyhands.co.in'},
  {id:'EMP003',name:'Sumer Singh',grade:'JM3',ctc:50000,ta:1600,special:'',mobile:399,pfRate:0,esicApplicable:false,visitTarget:12,revTarget:300000,newStoresTarget:5,territory:'Rajasthan',doj:'2024-03-15',pan:'ABCPS9012M',uan:'100234567892',bank:'ICICI Bank',account:'001234567890',ifsc:'ICIC0001234',phone:'9654321098',email:'sumer@happyhands.co.in'},
];

let emps=JSON.parse(localStorage.getItem('hh3_emps')||'null')||SAMPLE_EMPS;
let att=JSON.parse(localStorage.getItem('hh3_att')||'{}');
let tdsM=JSON.parse(localStorage.getItem('hh3_tds')||'{}');
// visits stored in att as key: \`\${empId}_\${y}_\${m}_\${d}_v\`
let curMonth=new Date().getMonth()+1;
let curYear=new Date().getFullYear();
let slipEmpId=emps[0]?.id||'EMP001';
let editEmpId=null;
let curTab='dashboard';

function save(k,v){try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}}

// ── SALARY FORMULAS ──────────────────────────────────────────
// ta_override: custom TA or null/'' for default 1600
// special_override: custom special or null/'' for auto-calculate as balance
function calcComp(ctc, ta_override, special_override, mobile_override, pf_rate, esic_enabled) {
  const basic=Math.round(ctc*0.40);
  const hra=Math.round(basic*0.50);
  const ta=(ta_override!=null&&ta_override!==''&&!isNaN(Number(ta_override)))?Number(ta_override):1600;
  const mobile=(mobile_override!=null&&mobile_override!==''&&!isNaN(Number(mobile_override)))?Number(mobile_override):399;
  // PF: editable rate. Standard statutory = 12% of Basic, capped ₹1,800/month. Default = 0 (not applicable).
  const pfPct=(pf_rate!=null&&String(pf_rate)!==''&&!isNaN(Number(pf_rate))&&Number(pf_rate)>0)?Number(pf_rate)/100:0;
  const erPF=pfPct>0?Math.min(Math.round(basic*pfPct),1800):0;
  const grat=Math.round(basic*0.0481); // Gratuity: 4.81% of Basic (statutory provision)
  let spec;
  if(special_override!=null&&special_override!==''&&!isNaN(Number(special_override))){
    spec=Number(special_override);
  } else {
    spec=Math.max(0,ctc-basic-hra-ta-mobile-erPF-grat);
  }
  const gross=basic+hra+ta+mobile+spec;
  const empPF=erPF;
  // ESIC: editable toggle. Standard = Employee 0.75% + Employer 3.25% if Gross ≤ ₹21,000. Default = off.
  const esicApplies=esic_enabled===true&&gross<=21000;
  const empESIC=esicApplies?Math.round(gross*0.0075):0;
  const erESIC=esicApplies?Math.round(gross*0.0325):0;
  const pt=gross>=10000?200:0;
  return{basic,hra,ta,mobile,spec,gross,erPF,grat,empPF,empESIC,erESIC,pt};
}

function daysIn(y,m){return new Date(y,m,0).getDate();}
function wdCount(y,m){let n=0;for(let d=1;d<=daysIn(y,m);d++)if(new Date(y,m-1,d).getDay()!==0)n++;return n;}

function calcPay(emp,y,m,tds=0){
  const sal=calcComp(emp.ctc,emp.ta,emp.special,emp.mobile,emp.pfRate,emp.esicApplicable);
  const wd=wdCount(y,m);
  const tot=daysIn(y,m);
  const c={P:0,A:0,HD:0,H:0,WO:0,CL:0,SL:0,EL:0,unm:0};
  let totalVisits=0;
  for(let d=1;d<=tot;d++){
    const s=att[\`\${emp.id}_\${y}_\${m}_\${d}\`];
    if(s&&c[s]!==undefined)c[s]++;
    else if(!s){if(new Date(y,m-1,d).getDay()===0)c.WO++;else c.unm++;}
    // count visits
    const v=Number(att[\`\${emp.id}_\${y}_\${m}_\${d}_v\`]||0);
    totalVisits+=v;
  }
  const lopD=c.A+c.HD*0.5+c.unm;
  const perD=sal.gross/wd;
  const lopDed=Math.round(lopD*perD);
  const grossPay=Math.max(0,sal.gross-lopDed);
  const empPF=sal.empPF;
  const pt=grossPay>=10000?200:0;
  const esicOn=grossPay<=21000;
  const empESIC=esicOn?Math.round(grossPay*0.0075):0;
  const totalDed=empPF+pt+empESIC+tds+lopDed;
  const netPay=Math.max(0,sal.gross-empPF-pt-empESIC-tds-lopDed);
  return{...sal,...c,wd,lopD,perD,lopDed,grossPay,empPF,pt,empESIC,tds,totalDed,netPay,totalVisits};
}

function INR(n){return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Math.round(Math.max(0,n||0)));}
function initials(name){return name.split(' ').map(n=>n[0]).join('').slice(0,2).toUpperCase();}
function gradeBadge(g){return\`<span class="badge \${GRADE_CLASS[g]||'bg-sm'}">\${g}</span>\`;}

// ── NAVIGATION ───────────────────────────────────────────────
function setTab(t){
  curTab=t;
  const ctx=document.getElementById('hdr-context');
  if(ctx){const emp=salFilterId&&t==='salary'?emps.find(e=>e.id===salFilterId):null;
    ctx.textContent=emp?emp.name+' · '+MONTHS[curMonth-1]+' '+curYear:MONTHS[curMonth-1]+' '+curYear;}
  document.querySelectorAll('.tab').forEach((el,i)=>{
    const tabs=['dashboard','employees','attendance','salary','slip'];
    el.classList.toggle('active',tabs[i]===t);
  });
  document.querySelectorAll('.page').forEach(el=>el.classList.remove('active'));
  document.getElementById(t==='slip'?'slip-page':t).classList.add('active');
  renderPage(t);
}
function prevMonth(){if(curMonth===1){curMonth=12;curYear--;}else curMonth--;renderPage(curTab);setTab(curTab);}
function nextMonth(){if(curMonth===12){curMonth=1;curYear++;}else curMonth++;renderPage(curTab);setTab(curTab);}
function renderPage(t){
  if(t==='dashboard')renderDash();
  else if(t==='employees')renderEmps();
  else if(t==='attendance')renderAtt();
  else if(t==='salary')renderSal();
  else if(t==='slip')renderSlip();
  else if(t==='kpi')renderKPI();
  else if(t==='pip')renderPIP();
}
function mnav(){
  return\`<div class="mnav">
    <button class="btn btn-sm" onclick="prevMonth()"><i class="ti ti-chevron-left"></i></button>
    <span class="mnav-label">\${MONTHS[curMonth-1]} \${curYear}</span>
    <button class="btn btn-sm" onclick="nextMonth()"><i class="ti ti-chevron-right"></i></button>
  </div>\`;
}

// ── DASHBOARD ────────────────────────────────────────────────
function renderDash(){
  const pays=emps.map(e=>calcPay(e,curYear,curMonth,Number(tdsM[\`\${e.id}_\${curYear}_\${curMonth}\`]||0)));
  const totGross=pays.reduce((a,p)=>a+p.grossPay,0);
  const totNet=pays.reduce((a,p)=>a+p.netPay,0);
  const totPF=emps.reduce((a,e)=>a+calcComp(e.ctc,e.ta,e.special,e.mobile,e.pfRate,e.esicApplicable).erPF,0);
  const totVisits=pays.reduce((a,p)=>a+p.totalVisits,0);

  const rows=emps.map((emp,i)=>{
    const p=pays[i];
    const visitTarget=(emp.visitTarget||12)*(p.P||0);
    const visitPct=visitTarget>0?Math.round((p.totalVisits/visitTarget)*100):0;
    return\`<tr class="row-stripe">
      <td><div style="font-weight:600;">\${emp.name}</div><div class="text-sub fs">\${GRADES[emp.grade]||emp.grade} · \${emp.territory}</div></td>
      <td>\${gradeBadge(emp.grade)}</td>
      <td style="font-weight:600;">\${INR(p.grossPay)}</td>
      <td style="color:\${p.lopD>0?'var(--red)':'#bbb'};">\${p.lopD>0?\`-\${INR(p.lopDed)}\`:'—'}</td>
      <td class="text-sub">\${INR(p.empPF)}</td>
      <td style="font-weight:700;color:var(--navy);">\${INR(p.netPay)}</td>
      <td><div style="font-weight:600;color:var(--orange);">\${p.totalVisits}</div><div style="font-size:10px;color:var(--subtext);">target: \${visitTarget}</div></td>
    </tr>\`;
  }).join('');

  document.getElementById('dashboard').innerHTML=\`
    <div class="page-hdr"><h2>Payroll overview</h2>\${mnav()}</div>
    <div class="g4 mb">
      <div class="stat"><div class="stat-lbl">Total employees</div><div class="stat-val">\${emps.length}</div><div class="stat-sub">Active on payroll</div></div>
      <div class="stat"><div class="stat-lbl">Total gross payable</div><div class="stat-val">\${INR(totGross)}</div><div class="stat-sub">\${MONTHS[curMonth-1]} \${curYear}</div></div>
      <div class="stat"><div class="stat-lbl">Total net pay</div><div class="stat-val">\${INR(totNet)}</div><div class="stat-sub">Take-home sum</div></div>
      <div class="stat"><div class="stat-lbl">Total store visits</div><div class="stat-val" style="color:var(--orange);">\${totVisits}</div><div class="stat-sub">All employees this month</div></div>
    </div>
    <div class="card">
      <div class="card-head"><h3>Employee summary — \${MONTHS[curMonth-1]} \${curYear}</h3></div>
      <table>
        <thead><tr><th>Employee</th><th>Grade</th><th>Gross Pay</th><th>LOP Deduction</th><th>PF</th><th>Net Pay</th><th>Total Visits</th></tr></thead>
        <tbody>\${rows}</tbody>
        <tfoot><tr style="background:var(--navy);color:#fff;">
          <td colspan="2" style="padding:8px 12px;font-weight:700;">TOTAL</td>
          <td style="padding:8px 12px;font-weight:700;">\${INR(totGross)}</td>
          <td></td><td></td>
          <td style="padding:8px 12px;font-weight:700;">\${INR(totNet)}</td>
          <td style="padding:8px 12px;font-weight:700;color:var(--orange);">\${totVisits} visits</td>
        </tr></tfoot>
      </table>
    </div>\`;
}

// ── EMPLOYEES ────────────────────────────────────────────────
function renderEmps(){
  const rows=emps.map((emp,i)=>{
    const s=calcComp(emp.ctc,emp.ta,emp.special,emp.mobile,emp.pfRate,emp.esicApplicable);
    const taLabel=emp.ta&&emp.ta!==1600?\`<span style="color:var(--orange);font-size:10px;">custom: \${INR(emp.ta)}</span>\`:INR(1600);
    const spLabel=emp.special&&emp.special!==''?\`<span style="color:var(--orange);font-size:10px;">custom: \${INR(emp.special)}</span>\`:'auto';
    return\`<tr class="row-stripe">
      <td style="font-weight:700;color:var(--navy);">\${emp.id}</td>
      <td><div style="font-weight:600;">\${emp.name}</div><div class="text-sub fs">\${emp.phone}</div></td>
      <td>\${gradeBadge(emp.grade)}</td>
      <td class="text-sub" style="font-size:12px;">\${GRADES[emp.grade]||emp.grade}</td>
      <td>\${emp.territory}</td>
      <td style="font-weight:600;color:var(--blue);">\${INR(emp.ctc)}</td>
      <td>\${taLabel}</td>
      <td><span style="font-size:11px;">\${INR(emp.mobile||399)}</span></td>
      <td>\${spLabel}</td>
      <td style="color:var(--navy);font-weight:600;">\${INR(s.gross-s.empPF-s.pt-s.empESIC)}</td>
      <td style="text-align:center;"><span style="background:var(--lnavy);padding:2px 8px;border-radius:4px;font-size:11px;font-weight:600;color:var(--navy);">\${emp.visitTarget||12}</span></td>
      <td><div style="display:flex;gap:4px;">
        <button class="btn btn-icon btn-sm" onclick="openEdit('\${emp.id}')" title="Edit"><i class="ti ti-edit"></i></button>
        <button class="btn btn-icon btn-sm btn-del" onclick="deleteEmp('\${emp.id}')" title="Delete"><i class="ti ti-trash"></i></button>
      </div></td>
    </tr>\`;
  }).join('');

  const ctcCards=emps.map(emp=>{
    const s=calcComp(emp.ctc,emp.ta,emp.special,emp.mobile,emp.pfRate,emp.esicApplicable);
    const isCustomTA=emp.ta&&emp.ta!==1600;
    const isCustomSpec=emp.special&&emp.special!=='';
    return\`<div class="card">
      <div style="padding:12px 14px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px;">
        <div class="initials">\${initials(emp.name)}</div>
        <div><div style="font-weight:700;font-size:13px;">\${emp.name}</div>
          <div class="text-sub fs">\${emp.grade} · \${emp.territory} · Target: \${emp.visitTarget||12} visits/day</div></div>
      </div>
      <div style="padding:12px 14px;font-size:12px;">
        \${[['Basic (40% of CTC)',s.basic,''],['HRA (50% of basic)',s.hra,''],
          [\`Travel Allowance\${isCustomTA?' ★':''}\`,s.ta,isCustomTA?'color:var(--orange);':''],
          ['Mobile Allowance',s.mobile||399,''],
          [\`Special Allowance\${isCustomSpec?' ★':''}\`,s.spec,isCustomSpec?'color:var(--orange);':''],
        ].map(([l,v,st])=>\`<div class="sal-row"><span style="color:var(--subtext);">\${l}</span><span style="\${st}">\${INR(v)}</span></div>\`).join('')}
        <div class="sal-row sal-sep"><b>Gross salary</b><b style="color:var(--green);">\${INR(s.gross)}</b></div>
        <div class="sal-row" style="color:var(--red);font-size:11px;"><span>− Employee PF</span><span>-\${INR(s.empPF)}</span></div>
        <div class="sal-row" style="color:var(--red);font-size:11px;"><span>− Professional tax</span><span>-\${INR(s.pt)}</span></div>
        \${s.empESIC>0?\`<div class="sal-row" style="color:var(--red);font-size:11px;"><span>− ESIC</span><span>-\${INR(s.empESIC)}</span></div>\`:''}
        <div class="sal-row sal-sep sal-total" style="color:var(--navy);"><span>Take-home (no LOP)</span><span>\${INR(s.gross-s.empPF-s.pt-s.empESIC)}</span></div>
        <div class="sal-row" style="font-size:11px;color:var(--subtext);"><span>Total CTC</span><span style="color:var(--blue);">\${INR(emp.ctc)}</span></div>
        \${isCustomTA||isCustomSpec?\`<div style="margin-top:6px;padding:4px 6px;background:var(--lamber);border-radius:4px;font-size:10px;color:var(--amber);"><i class="ti ti-info-circle" style="font-size:10px;"></i> ★ = custom override applied</div>\`:''}
      </div>
    </div>\`;
  }).join('');

  document.getElementById('employees').innerHTML=\`
    <div class="page-hdr"><h2>Employee master</h2><button class="btn btn-orange" onclick="openAdd()"><i class="ti ti-plus"></i> Add employee</button></div>
    <div class="card mb">
      <table>
        <thead><tr><th>ID</th><th>Name</th><th>Grade</th><th>Designation</th><th>Territory</th><th>CTC/Month</th><th>Travel Allow.</th><th>Mobile Allow.</th><th>Special Allow.</th><th>Take-Home</th><th>Visit Target</th><th>Actions</th></tr></thead>
        <tbody>\${rows}</tbody>
      </table>
    </div>
    <h3 style="font-size:14px;font-weight:700;color:var(--navy);margin-bottom:12px;">CTC breakdown cards</h3>
    <div class="g3">\${ctcCards}</div>\`;
}

// ── ATTENDANCE ───────────────────────────────────────────────
function renderAtt(){
  const days=daysIn(curYear,curMonth);
  function getS(empId,d){
    const s=att[\`\${empId}_\${curYear}_\${curMonth}_\${d}\`];
    return s||(new Date(curYear,curMonth-1,d).getDay()===0?'WO':null);
  }
  const legend=SC.map(s=>{
    const st=ST[s];
    return\`<div class="legend-item"><div class="legend-badge s-\${s}">\${s}</div>\${st.l}</div>\`;
  }).join('');

  let dayHdrs='';
  for(let d=1;d<=days;d++){
    const dow=new Date(curYear,curMonth-1,d).getDay();
    dayHdrs+=\`<th style="\${dow===0?'background:#4b5563;':''}">\${d}<br><span style="font-size:8px;">\${DS[dow]}</span></th>\`;
  }

  let empRows=emps.map((emp,ei)=>{
    const cntMap={P:0,A:0,HD:0,H:0,WO:0,CL:0,SL:0,EL:0,unm:0};
    let totalVisits=0;
    let cells='';
    for(let d=1;d<=days;d++){
      const s=getS(emp.id,d);
      const dow=new Date(curYear,curMonth-1,d).getDay();
      const visits=Number(att[\`\${emp.id}_\${curYear}_\${curMonth}_\${d}_v\`]||0);
      if(visits>0) totalVisits+=visits;
      const showVisit=s&&VISIT_DAYS.includes(s);
      if(s){
        const st=ST[s];
        if(cntMap[s]!==undefined)cntMap[s]++;
        const visitInput=showVisit
          ?\`<input type="number" min="0" max="99" class="visit-input" value="\${visits||''}" placeholder="0"
             title="Visits on \${d} \${MONTHS[curMonth-1]}"
             onchange="setVisit('\${emp.id}',\${d},this.value)"
             onclick="event.stopPropagation()">\`
          :\`<div style="width:28px;height:14px;"></div>\`;
        cells+=\`<td style="\${dow===0?'background:#f8f8f8;':''}">
          <div class="att-cell-wrap">
            <button class="att-btn s-\${s}" onclick="cycleAtt('\${emp.id}',\${d})" title="\${st.l} — click to change">\${s}</button>
            \${visitInput}
          </div></td>\`;
      } else {
        cntMap.unm++;
        cells+=\`<td><div class="att-cell-wrap">
          <button class="att-empty" onclick="setAttS('\${emp.id}',\${d},'P')" title="Click to mark Present">+</button>
          <div style="width:28px;height:14px;"></div>
        </div></td>\`;
      }
    }
    const lopD=cntMap.A+cntMap.HD*0.5+cntMap.unm;
    const wd=wdCount(curYear,curMonth);
    const tgt=(emp.visitTarget||12)*(cntMap.P||0);
    const visitColor=totalVisits>=tgt?'var(--green)':(totalVisits>0?'var(--orange)':'var(--subtext)');
    return\`<tr>
      <td class="att-emp-cell">
        <div class="att-emp-name">\${emp.name}</div>
        <div class="att-emp-grade">\${GRADES[emp.grade]||emp.grade} | Target: \${emp.visitTarget||12}/day</div>
      </td>
      \${cells}
      <td class="att-sum text-green">\${cntMap.P}</td>
      <td class="att-sum" style="color:\${lopD>0?'var(--red)':'#bbb'};">\${lopD}</td>
      <td class="att-sum" style="color:\${visitColor};font-weight:700;">\${totalVisits}<br><span style="font-size:8px;color:var(--subtext);">/\${tgt}</span></td>
      <td class="att-sum text-sub">\${wd}</td>
    </tr>\`;
  }).join('');

  document.getElementById('attendance').innerHTML=\`
    <div class="page-hdr">
      <h2>Attendance — \${MONTHS[curMonth-1]} \${curYear}</h2>
      <div style="display:flex;gap:8px;align-items:center;">\${mnav()}
        <button class="btn btn-green btn-sm" onclick="markAllPresent()"><i class="ti ti-check"></i> Mark all present</button>
        <button class="btn btn-primary btn-sm" onclick="emps.forEach(e=>downloadMuster(e.id))"><i class="ti ti-download"></i> Download All</button>
      </div>
    </div>
    <div class="legend">\${legend}
      <span style="font-size:11px;color:#aaa;margin-left:4px;">Click cell to cycle status · Enter number below status for visit count</span>
    </div>
    <div class="card">
      <div class="att-wrap">
        <table class="att-table">
          <thead><tr>
            <th style="text-align:left;min-width:145px;position:sticky;left:0;z-index:10;">Employee</th>
            \${dayHdrs}
            <th>Pres.</th><th>LOP</th><th style="color:#ffd700;">Visits</th><th>WDays</th>
          </tr></thead>
          <tbody>\${empRows}</tbody>
        </table>
      </div>
    </div>\`;
}

function cycleAtt(empId,d){
  const k=\`\${empId}_\${curYear}_\${curMonth}_\${d}\`;
  const cur=att[k]||(new Date(curYear,curMonth-1,d).getDay()===0?'WO':null);
  const idx=cur?SC.indexOf(cur):-1;
  att[k]=SC[(idx+1)%SC.length];
  // Clear visit count if new status doesn't support visits
  if(!VISIT_DAYS.includes(att[k])){delete att[\`\${k}_v\`];}
  save('hh3_att',att);
  renderAtt();
}
function setAttS(empId,d,s){
  att[\`\${empId}_\${curYear}_\${curMonth}_\${d}\`]=s;
  save('hh3_att',att);
  renderAtt();
}
function setVisit(empId,d,v){
  const k=\`\${empId}_\${curYear}_\${curMonth}_\${d}_v\`;
  att[k]=Number(v)||0;
  save('hh3_att',att);
}
function markAllPresent(){
  const days=daysIn(curYear,curMonth);
  emps.forEach(emp=>{
    for(let d=1;d<=days;d++){
      const k=\`\${emp.id}_\${curYear}_\${curMonth}_\${d}\`;
      if(!att[k])att[k]=new Date(curYear,curMonth-1,d).getDay()===0?'WO':'P';
    }
  });
  save('hh3_att',att);
  renderAtt();
}

// ── SALARY ───────────────────────────────────────────────────
function renderSal(){
  // ── Filter chips ──────────────────────────────────────
  const chipAll = \`<button class="chip\${!salFilterId?' active':''}" onclick="setSalFilter(null)">👥 All Employees</button>\`;
  const empChips = emps.map(e=>\`<button class="chip\${salFilterId===e.id?' active':''}" onclick="setSalFilter('\${e.id}')">\${e.name.split(' ')[0]}</button>\`).join('');

  // ── Stats table ────────────────────────────────────────
  const statsRows = emps.map(emp=>{
    const p = calcPay(emp,curYear,curMonth,Number(tdsM[\`\${emp.id}_\${curYear}_\${curMonth}\`]||0));
    const convT = calcConvTotal(emp,curYear,curMonth);
    const tripT = getEmpOutstationTotal(emp.id,curYear,curMonth);
    const tripCnt = getEmpTripCount(emp.id,curYear,curMonth);
    const totalR = convT + tripT;
    const maxConv = Math.max(1,...emps.map(e=>calcConvTotal(e,curYear,curMonth)));
    const maxTrip = Math.max(1,...emps.map(e=>getEmpOutstationTotal(e.id,curYear,curMonth)));
    const maxR = Math.max(1,...emps.map(e=>calcConvTotal(e,curYear,curMonth)+getEmpOutstationTotal(e.id,curYear,curMonth)));
    return \`<tr style="\${salFilterId&&salFilterId!==emp.id?'opacity:0.45':''}">
      <td><div style="font-weight:600;">\${emp.name}</div><div style="font-size:10px;color:var(--subtext);">\${emp.grade} · \${emp.territory}</div></td>
      <td style="text-align:center;">\${p.P||0} / \${p.wd}</td>
      <td><div style="font-weight:500;color:var(--orange);">\${INR(convT)}</div><div class="stat-bar-bg"><div class="stat-bar-fg" style="width:\${Math.round((convT/maxConv)*100)}%;background:var(--orange);"></div></div></td>
      <td style="text-align:center;">\${tripCnt} trip\${tripCnt!==1?'s':''}</td>
      <td><div style="font-weight:500;color:var(--blue);">\${INR(tripT)}</div><div class="stat-bar-bg"><div class="stat-bar-fg" style="width:\${Math.round((tripT/maxTrip)*100)}%;background:var(--blue);"></div></div></td>
      <td><div style="font-weight:700;color:var(--navy);">\${INR(totalR)}</div><div class="stat-bar-bg"><div class="stat-bar-fg" style="width:\${Math.round((totalR/maxR)*100)}%;background:var(--green);"></div></div></td>
      <td style="font-weight:700;color:var(--navy);">\${INR(p.netPay)}</td>
      <td><button class="muster-btn" onclick="downloadMuster('\${emp.id}')">📄 Muster</button></td>
    </tr>\`;
  }).join('');

  const totalNetPayAll = emps.reduce((a,e)=>a+calcPay(e,curYear,curMonth,Number(tdsM[\`\${e.id}_\${curYear}_\${curMonth}\`]||0)).netPay,0);
  const filteredEmps = salFilterId ? emps.filter(e=>e.id===salFilterId) : emps;
  const cards=filteredEmps.map(emp=>{
    const k=\`\${emp.id}_\${curYear}_\${curMonth}\`;
    const tds=Number(tdsM[k]||0);
    const p=calcPay(emp,curYear,curMonth,tds);
    const ini=initials(emp.name);
    const isCustomTA=emp.ta&&emp.ta!==1600;
    const isCustomSpec=emp.special&&emp.special!=='';
    const visitTarget=(emp.visitTarget||12)*(p.P||0);
    const visitPct=visitTarget>0?Math.min(100,Math.round((p.totalVisits/visitTarget)*100)):0;
    const visitColor=p.totalVisits>=visitTarget?'var(--green)':(p.totalVisits>0?'var(--orange)':'var(--red)');

    const earnRows=[
      ['Basic salary',p.basic,''],
      ['HRA',p.hra,''],
      [\`Travel allowance\${isCustomTA?' ★':''}\`,p.ta,isCustomTA?'color:var(--orange);font-weight:600;':''],
      ['Mobile allowance',p.mobile||399,''],
      [\`Special allowance\${isCustomSpec?' ★':''}\`,p.spec,isCustomSpec?'color:var(--orange);font-weight:600;':''],
    ].map(([l,v,st])=>\`<div class="sal-row"><span style="color:var(--subtext);">\${l}</span><span style="\${st}">\${INR(v)}</span></div>\`).join('');

    const dedRows=[[p.empPF>0?\`Employee PF (\${Math.round((p.empPF/p.basic)*100)}%)\`:p.empPF===0?'Employee PF (Not applicable)':'Employee PF',p.empPF],['Professional tax',p.pt],
      ...(p.empESIC>0?[['ESIC (0.75%)',p.empESIC]]:[]),
    ].map(([l,v])=>\`<div class="sal-row"><span style="color:var(--subtext);">\${l}</span><span style="color:var(--red);">-\${INR(v)}</span></div>\`).join('');

    const attMini=[
      ['Present',p.P||0,''],['Half Day',p.HD||0,''],['CL+SL+EL',(p.CL||0)+(p.SL||0)+(p.EL||0),''],
      ['Holiday',p.H||0,''],['LOP Days',Math.round(p.lopD*10)/10,p.lopD>0?'var(--red)':''],['Working Days',p.wd,''],
    ].map(([l,v,c])=>\`<div class="att-mini-cell"><div class="att-mini-val" style="\${c?'color:'+c:''};">\${v}</div><div class="att-mini-lbl">\${l}</div></div>\`).join('');

    return\`<div class="sal-card">
      <div class="sal-head">
        <div style="display:flex;align-items:center;gap:10px;">
          <div style="width:34px;height:34px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:12px;">\${ini}</div>
          <div><div style="font-weight:700;font-size:14px;">\${emp.name}</div>
            <div style="font-size:11px;opacity:0.65;">\${GRADES[emp.grade]||emp.grade} · \${emp.territory} · Visit target: \${emp.visitTarget||12}/day</div></div>
        </div>
        <div style="text-align:right;"><div style="font-size:10px;opacity:0.65;">NET PAY</div><div style="font-size:22px;font-weight:800;">\${INR(p.netPay)}</div></div>
      </div>
      <div class="sal-body">
        <div class="sal-col">
          <div class="sal-col-title">Earnings</div>
          \${earnRows}
          <div class="sal-row sal-sep sal-total"><span>Gross salary</span><span style="color:var(--green);">\${INR(p.gross)}</span></div>
          \${p.lopDed>0?\`<div class="lop-box"><span>LOP (\${p.lopD}d × \${INR(Math.round(p.perD))})</span><span>-\${INR(p.lopDed)}</span></div>\`:''}
          <div class="sal-row sal-total" style="color:var(--navy);padding-top:6px;border-top:1px solid var(--border);margin-top:4px;">
            <span>Gross payable</span><span>\${INR(p.grossPay)}</span>
          </div>
          \${(isCustomTA||isCustomSpec)?\`<div style="margin-top:8px;padding:5px 7px;background:var(--lamber);border-radius:5px;font-size:10px;color:var(--amber);"><i class="ti ti-info-circle" style="font-size:10px;"></i> ★ Custom allowance override active. <a href="#" onclick="openEdit('\${emp.id}');return false;" style="color:var(--navy);">Edit →</a></div>\`:''}
        </div>
        <div class="sal-col">
          <div class="sal-col-title">Deductions</div>
          \${dedRows}
          <div style="display:flex;align-items:center;justify-content:space-between;font-size:12px;padding:4px 0;">
            <span style="color:var(--subtext);">TDS / Income Tax</span>
            <input type="number" min="0" value="\${tds||''}" placeholder="0" style="width:80px;text-align:right;padding:3px 6px;font-size:12px;" oninput="setTds('\${k}',this.value)">
          </div>
          <div class="sal-row sal-sep sal-total" style="color:var(--red);"><span>Total deductions</span><span>-\${INR(p.totalDed)}</span></div>
          <div class="net-box"><div class="net-lbl">Net take-home pay</div><div class="net-val">\${INR(p.netPay)}</div></div>
          <div class="er-box">
            <div style="font-weight:700;margin-bottom:5px;color:var(--navy);">Employer contributions</div>
            <div class="sal-row fs"><span style="color:var(--subtext);">Employer PF</span><span>\${INR(p.erPF)}</span></div>
            <div class="sal-row fs"><span style="color:var(--subtext);">Gratuity prov.</span><span>\${INR(p.grat)}</span></div>
            \${p.erESIC>0?\`<div class="sal-row fs"><span style="color:var(--subtext);">Employer ESIC</span><span>\${INR(p.erESIC)}</span></div>\`:''}
            <div class="sal-row fs sal-sep" style="color:var(--navy);font-weight:700;"><span>Total CTC</span><span>\${INR(emp.ctc)}</span></div>
          </div>
        </div>
        <div class="sal-col">
          <div class="sal-col-title">Attendance & Visits</div>
          <div class="att-mini">\${attMini}</div>
          <div style="font-size:11px;color:var(--subtext);text-align:center;margin-bottom:10px;">Per day rate: \${INR(Math.round(p.perD))}</div>
          <!-- Visit tracker card -->
          <div style="background:var(--lnavy);border-radius:8px;padding:10px;">
            <div style="font-size:10px;font-weight:700;color:var(--navy);margin-bottom:6px;"><i class="ti ti-map-pin" style="font-size:10px;"></i> Store visits this month</div>
            <div style="display:flex;align-items:baseline;gap:6px;margin-bottom:6px;">
              <span style="font-size:24px;font-weight:800;color:\${visitColor};">\${p.totalVisits}</span>
              <span style="font-size:11px;color:var(--subtext);">/ \${visitTarget} target</span>
            </div>
            <div style="background:#e2e8f0;border-radius:20px;height:6px;overflow:hidden;margin-bottom:4px;">
              <div style="height:100%;width:\${visitPct}%;background:\${visitColor};border-radius:20px;transition:width 0.3s;"></div>
            </div>
            <div style="font-size:10px;color:var(--subtext);">\${visitPct}% of target (\${emp.visitTarget||12} visits/day × \${p.P||0} present days)</div>
          </div>
          <div style="margin-top:10px;"><button class="btn btn-orange" style="width:100%;justify-content:center;" onclick="goToSlip('\${emp.id}')"><i class="ti ti-file-text"></i> View salary slip</button></div>
        </div>
      </div>
    </div>\`;
  }).join('');

  const totGross=emps.reduce((a,e)=>a+calcPay(e,curYear,curMonth).grossPay,0);
  const totNet=emps.reduce((a,e)=>a+calcPay(e,curYear,curMonth,Number(tdsM[\`\${e.id}_\${curYear}_\${curMonth}\`]||0)).netPay,0);
  const totPF=emps.reduce((a,e)=>a+calcComp(e.ctc,e.ta,e.special,e.mobile,e.pfRate,e.esicApplicable).erPF,0);
  const totVisits=emps.reduce((a,e)=>a+calcPay(e,curYear,curMonth).totalVisits,0);

  document.getElementById('salary').innerHTML=\`
    <div class="page-hdr"><h2>Salary calculation — \${MONTHS[curMonth-1]} \${curYear}</h2>\${mnav()}</div>
    <div class="filter-chips">\${chipAll}\${empChips}</div>
    <div class="stats-card">
      <div style="padding:10px 14px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;">
        <div style="font-weight:600;font-size:13px;color:var(--navy);">📊 Expense & Reimbursement Statistics — \${MONTHS[curMonth-1]} \${curYear}</div>
        <div style="font-size:11px;color:var(--subtext);">Daily conveyance + outstation travel per employee</div>
      </div>
      <table>
        <thead><tr>
          <th>Employee</th><th>Attendance</th>
          <th>Daily Conv.</th><th>Outstation Trips</th>
          <th>Outstation Exp.</th><th>Total Reimbursable</th>
          <th>Net Pay</th><th>Report</th>
        </tr></thead>
        <tbody>\${statsRows}</tbody>
        <tfoot><tr style="background:var(--lnavy);">
          <td style="padding:8px 12px;font-weight:700;color:var(--navy);" colspan="2">TOTAL</td>
          <td style="padding:8px 12px;font-weight:700;color:var(--orange);">\${INR(emps.reduce((a,e)=>a+calcConvTotal(e,curYear,curMonth),0))}</td>
          <td style="padding:8px 12px;font-weight:600;color:var(--subtext);">\${emps.reduce((a,e)=>a+getEmpTripCount(e.id,curYear,curMonth),0)} trips</td>
          <td style="padding:8px 12px;font-weight:700;color:var(--blue);">\${INR(emps.reduce((a,e)=>a+getEmpOutstationTotal(e.id,curYear,curMonth),0))}</td>
          <td style="padding:8px 12px;font-weight:700;color:var(--green);">\${INR(emps.reduce((a,e)=>a+calcConvTotal(e,curYear,curMonth)+getEmpOutstationTotal(e.id,curYear,curMonth),0))}</td>
          <td style="padding:8px 12px;font-weight:700;color:var(--navy);">\${INR(totalNetPayAll)}</td>
          <td></td>
        </tr></tfoot>
      </table>
    </div>
    \${cards}
    <div class="card">
      <div class="card-head"><h3>Monthly payroll summary</h3></div>
      <div class="sum-bar">
        <div class="sum-item"><div class="sum-lbl">Total gross payable</div><div class="sum-val" style="color:var(--blue);">\${INR(totGross)}</div></div>
        <div class="sum-item"><div class="sum-lbl">Employer PF total</div><div class="sum-val" style="color:var(--amber);">\${INR(totPF)}</div></div>
        <div class="sum-item"><div class="sum-lbl">Total net pay</div><div class="sum-val" style="color:var(--green);">\${INR(totNet)}</div></div>
        <div class="sum-item"><div class="sum-lbl">Total store visits</div><div class="sum-val" style="color:var(--orange);">\${totVisits}</div></div>
      </div>
    </div>\`;
}
function setTds(k,v){tdsM[k]=Number(v)||0;save('hh3_tds',tdsM);}

// ── SALARY SLIP ──────────────────────────────────────────────
function goToSlip(empId){slipEmpId=empId;setTab('slip');}
function renderSlip(){
  const empOpts=emps.map(e=>\`<option value="\${e.id}"\${e.id===slipEmpId?' selected':''}>\${e.name} (\${e.id})</option>\`).join('');
  const emp=emps.find(e=>e.id===slipEmpId);
  if(!emp){document.getElementById('slip-page').innerHTML='<p style="padding:20px">No employee selected.</p>';return;}
  const tds=Number(tdsM[\`\${emp.id}_\${curYear}_\${curMonth}\`]||0);
  const p=calcPay(emp,curYear,curMonth,tds);
  const isCustomTA=emp.ta&&emp.ta!==1600;
  const isCustomSpec=emp.special&&emp.special!=='';

  const earnHtml=[['Basic salary',p.basic,''],['House rent allowance',p.hra,''],
    [\`Travel allowance\${isCustomTA?' ★':''}\`,p.ta,isCustomTA?'color:var(--orange);font-weight:600;':''],
    ['Mobile allowance',p.mobile,''],
    [\`Special allowance\${isCustomSpec?' ★':''}\`,p.spec,isCustomSpec?'color:var(--orange);font-weight:600;':''],
  ].map(([l,v,st])=>\`<tr><td style="color:var(--subtext);">\${l}</td><td style="\${st}">\${INR(v)}</td></tr>\`).join('');
  const dedHtml=[[p.empPF>0?\`Employee PF (\${Math.round((p.empPF/p.basic)*100)}% of basic)\`:'Employee PF (Not applicable — 0%)',p.empPF],['Professional tax (Gujarat)',p.pt],
    ...(p.empESIC>0?[['ESIC (0.75%)',p.empESIC]]:[]),['TDS / income tax',p.tds||0],
  ].map(([l,v])=>\`<tr><td style="color:var(--subtext);">\${l}</td><td style="color:var(--red);">\${INR(v)}</td></tr>\`).join('');

  const visitTarget=(emp.visitTarget||12)*(p.P||0);
  const attHtml=[['Working days',p.wd],['Present',p.P||0],['CL',p.CL||0],['SL',p.SL||0],
    ['EL',p.EL||0],['Holiday',p.H||0],['Half day',p.HD||0],['LOP',Math.round(p.lopD*10)/10],
    ['Total visits',p.totalVisits],
  ].map(([l,v])=>\`<div class="slip-att-item"><div class="slip-att-val" style="\${l==='LOP'&&v>0?'color:var(--red);':l==='Total visits'?'color:var(--orange);':''}">\${v}</div><div class="slip-att-lbl">\${l}</div></div>\`).join('');

  document.getElementById('slip-page').innerHTML=\`
    <div class="page-hdr no-print">
      <h2>Salary slip generator</h2>
      <div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;">
        <select style="width:200px;" onchange="slipEmpId=this.value;renderSlip();">\${empOpts}</select>
        \${mnav()}
        <button class="btn btn-primary" onclick="window.print()"><i class="ti ti-printer"></i> Print / Download PDF</button>
      </div>
    </div>
    <div class="slip">
      <div class="slip-hdr">
        <div class="slip-co">HAPPY HANDS GLOBAL LLP</div>
        <div class="slip-addr">Plot No.12, TD Industrial Estate, Changodar, Ahmedabad – 382213, Gujarat</div>
        <div class="slip-addr">GST: 24AARFH4921J1Z5 | +91 9726893969 | www.happy-hands.co.in</div>
        <div class="slip-pill">SALARY SLIP — \${MONTHS[curMonth-1].toUpperCase()} \${curYear}</div>
      </div>
      <div class="slip-grid">
        <div class="slip-panel">
          <div class="slip-sec-title">Employee information</div>
          \${[['Name',emp.name],['Employee ID',emp.id],['Designation',GRADES[emp.grade]||emp.grade],['Grade',emp.grade],['Territory',emp.territory],['Date of joining',emp.doj],['Visit target',\`\${emp.visitTarget||12} stores/day\`]].map(([l,v])=>\`<div class="slip-row"><span class="slip-row-label">\${l}</span><span style="font-weight:500;">: \${v||'—'}</span></div>\`).join('')}
        </div>
        <div class="slip-panel">
          <div class="slip-sec-title">Payment & bank details</div>
          \${[['PAN number',emp.pan],['UAN (EPFO)',emp.uan],['Bank name',emp.bank],['Account no.',emp.account],['IFSC code',emp.ifsc],['Pay period',MONTHS[curMonth-1]+' '+curYear],['Days worked',\`\${p.P||0} of \${p.wd}\`]].map(([l,v])=>\`<div class="slip-row"><span class="slip-row-label">\${l}</span><span style="font-weight:500;">: \${v||'—'}</span></div>\`).join('')}
        </div>
      </div>
      <div class="slip-att">
        <div class="slip-sec-title">Attendance & Store visit summary</div>
        <div class="slip-att-row">\${attHtml}</div>
      </div>
      <div class="slip-earn-ded">
        <div class="slip-earn">
          <div class="slip-sec-title" style="color:var(--green);">Earnings</div>
          <table class="slip-table">
            <thead><tr><th>Component</th><th>Amount (₹)</th></tr></thead>
            <tbody>\${earnHtml}</tbody>
            <tfoot>
              <tr><td>Gross salary</td><td style="color:var(--green);">\${INR(p.gross)}</td></tr>
              \${p.lopDed>0?\`<tr class="lop-row"><td>LOP deduction (\${p.lopD} days)</td><td>-\${INR(p.lopDed)}</td></tr>\`:''}
              <tr class="gp-row"><td>Gross payable</td><td>\${INR(p.grossPay)}</td></tr>
            </tfoot>
          </table>
        </div>
        <div class="slip-ded">
          <div class="slip-sec-title" style="color:var(--red);">Deductions</div>
          <table class="slip-table">
            <thead><tr><th>Component</th><th>Amount (₹)</th></tr></thead>
            <tbody>\${dedHtml}</tbody>
            <tfoot><tr><td>Total deductions</td><td style="color:var(--red);">-\${INR(p.totalDed)}</td></tr></tfoot>
          </table>
          <div class="er-box" style="margin-top:12px;">
            <div style="font-weight:700;color:var(--navy);margin-bottom:5px;">Employer contributions (info only)</div>
            <div class="sal-row fs"><span style="color:var(--subtext);">Employer PF</span><span>\${INR(p.erPF)}</span></div>
            <div class="sal-row fs"><span style="color:var(--subtext);">Gratuity provision</span><span>\${INR(p.grat)}</span></div>
            \${p.erESIC>0?\`<div class="sal-row fs"><span style="color:var(--subtext);">ESIC (employer)</span><span>\${INR(p.erESIC)}</span></div>\`:''}
            <div class="sal-row fs sal-sep" style="font-weight:700;color:var(--navy);"><span>Total CTC</span><span>\${INR(emp.ctc)}</span></div>
          </div>
        </div>
      </div>
      <div class="slip-net">
        <div>
          <div class="slip-net-lbl">Net pay (take-home)</div>
          <div class="slip-net-val">\${INR(p.netPay)}</div>
        </div>
        <div style="text-align:right;font-size:11px;opacity:0.65;">
          <div>CTC: \${INR(emp.ctc)} / month</div>
          <div>Payment mode: Bank transfer</div>
          <div>Store visits: \${p.totalVisits} / \${visitTarget} target</div>
          <div style="margin-top:6px;">Generated: \${new Date().toLocaleDateString('en-IN')}</div>
        </div>
      </div>
      <div class="slip-foot">
        <div style="font-size:10px;color:var(--subtext);">
          <div>System-generated salary slip — Happy Hands Global LLP</div>
          <div>TD Industrial Estate, Changodar, Ahmedabad – 382213</div>
        </div>
        <div class="slip-sign">
          <div class="slip-sign-line"></div>
          <div class="slip-sign-lbl">Authorised signatory</div>
        </div>
      </div>
    </div>\`;
}

// ── EMPLOYEE FORM ────────────────────────────────────────────
function previewSalary(){
  const ctc=Number(document.getElementById('f-ctc')?.value||0);
  const ta=document.getElementById('f-ta')?.value;
  const spec=document.getElementById('f-special')?.value;
  const prev=document.getElementById('salary-preview');
  const content=document.getElementById('preview-content');
  if(!ctc||ctc<5000){if(prev)prev.style.display='none';return;}
  const mob=document.getElementById('f-mobile')?.value;
  const pfR=document.getElementById('f-pfrate')?.value;
  const esicOn=document.getElementById('f-esic')?.checked||false;
  const s=calcComp(ctc,ta,spec,mob,pfR,esicOn);
  if(prev)prev.style.display='block';
  if(content)content.innerHTML=[
    ['Basic',INR(s.basic),''],['HRA',INR(s.hra),''],['Travel Allow.',INR(s.ta),ta&&ta!=1600?'color:var(--orange);':''],
    ['Mobile Allow.',INR(s.mobile),mob&&mob!=399?'color:var(--orange);':''],
    ['Special Allow.',INR(s.spec),spec&&spec!==''?'color:var(--orange);':''],
    ['Gross',INR(s.gross),'font-weight:700;color:var(--green);'],['Emp. PF','-'+INR(s.empPF),'color:var(--red);'],
    ['Prof. Tax','-'+INR(s.pt),'color:var(--red);'],['Take-Home',INR(s.gross-s.empPF-s.pt-s.empESIC),'font-weight:700;color:var(--navy);'],
  ].map(([l,v,st])=>\`<div style="background:#fff;border-radius:5px;padding:6px 8px;"><div style="font-size:9px;color:var(--subtext);">\${l}</div><div style="font-size:12px;font-weight:600;\${st}">\${v}</div></div>\`).join('');
}

function openAdd(){
  editEmpId=null;
  document.getElementById('modal-title').textContent='Add New Employee';
  ['name','phone','territory','ctc','doj','pan','uan','bank','account','ifsc','email','ta','special','mobile','pfrate'].forEach(f=>{
    const el=document.getElementById('f-'+f);if(el)el.value='';
  });
  document.getElementById('f-grade').value='JM1';
  const esicResetEl=document.getElementById('f-esic');if(esicResetEl)esicResetEl.checked=false;
  document.getElementById('f-visit-target').value='';
  const prev=document.getElementById('salary-preview');if(prev)prev.style.display='none';
  document.getElementById('emp-modal').style.display='flex';
}
function openEdit(id){
  editEmpId=id;
  const emp=emps.find(e=>e.id===id);
  if(!emp)return;
  document.getElementById('modal-title').textContent='Edit Employee';
  document.getElementById('f-name').value=emp.name||'';
  document.getElementById('f-phone').value=emp.phone||'';
  document.getElementById('f-grade').value=emp.grade||'JM1';
  document.getElementById('f-territory').value=emp.territory||'';
  document.getElementById('f-ctc').value=emp.ctc||'';
  document.getElementById('f-doj').value=emp.doj||'';
  document.getElementById('f-pan').value=emp.pan||'';
  document.getElementById('f-uan').value=emp.uan||'';
  document.getElementById('f-bank').value=emp.bank||'';
  document.getElementById('f-account').value=emp.account||'';
  document.getElementById('f-ifsc').value=emp.ifsc||'';
  document.getElementById('f-email').value=emp.email||'';
  document.getElementById('f-ta').value=emp.ta&&emp.ta!==1600?emp.ta:'';
  document.getElementById('f-special').value=emp.special||'';
  document.getElementById('f-mobile').value=emp.mobile||399;
  const pfEl=document.getElementById('f-pfrate');if(pfEl)pfEl.value=emp.pfRate>0?emp.pfRate:'';
  const esicEl=document.getElementById('f-esic');if(esicEl)esicEl.checked=emp.esicApplicable||false;
  document.getElementById('f-visit-target').value=emp.visitTarget||'';
  previewSalary();
  document.getElementById('emp-modal').style.display='flex';
}
function closeModal(){document.getElementById('emp-modal').style.display='none';}
function gradeChanged(){}
function saveEmployee(){
  const name=document.getElementById('f-name').value.trim();
  const ctc=Number(document.getElementById('f-ctc').value);
  if(!name||!ctc){alert('Name and CTC are required.');return;}
  const grade=document.getElementById('f-grade').value;
  const taVal=document.getElementById('f-ta').value.trim();
  const specVal=document.getElementById('f-special').value.trim();
  const data={
    name,grade,ctc,designation:GRADES[grade]||grade,
    territory:document.getElementById('f-territory').value.trim(),
    phone:document.getElementById('f-phone').value.trim(),
    doj:document.getElementById('f-doj').value,
    pan:document.getElementById('f-pan').value.trim().toUpperCase(),
    uan:document.getElementById('f-uan').value.trim(),
    bank:document.getElementById('f-bank').value.trim(),
    account:document.getElementById('f-account').value.trim(),
    ifsc:document.getElementById('f-ifsc').value.trim().toUpperCase(),
    email:document.getElementById('f-email').value.trim(),
    ta:taVal&&!isNaN(Number(taVal))?Number(taVal):1600,
    special:specVal&&!isNaN(Number(specVal))?Number(specVal):'',
    mobile:Number(document.getElementById('f-mobile')?.value||399)||399,
    pfRate:document.getElementById('f-pfrate')?.value?.trim()!==''?Number(document.getElementById('f-pfrate').value):0,
    esicApplicable:document.getElementById('f-esic')?.checked||false,
    visitTarget:Number(document.getElementById('f-visit-target').value||12)||12,
  };
  if(editEmpId){emps=emps.map(e=>e.id===editEmpId?{...data,id:editEmpId}:e);}
  else{const id='EMP'+String(Date.now()).slice(-4);emps.push({...data,id});}
  save('hh3_emps',emps);
  closeModal();
  renderPage(curTab);
}
function deleteEmp(id){
  if(!confirm('Delete this employee? This cannot be undone.'))return;
  emps=emps.filter(e=>e.id!==id);
  save('hh3_emps',emps);
  renderEmps();
}



// ══════════════════════════════════════════════════════════════
// CITY CLASSIFICATION DATA (from HR Policy)
// ══════════════════════════════════════════════════════════════
const CITY_CLASS_MAP = {
  // North
  'Delhi':{z:'North',c:'Super A'},'New Delhi':{z:'North',c:'Super A'},
  'Chandigarh':{z:'North',c:'A'},
  'Agra':{z:'North',c:'B'},'Amritsar':{z:'North',c:'B'},'Allahabad':{z:'North',c:'B'},
  'Bareilly':{z:'North',c:'B'},'Bareli':{z:'North',c:'B'},'Dehradun':{z:'North',c:'B'},
  'Ghaziabad':{z:'North',c:'B'},'Jalandhar':{z:'North',c:'B'},'Jammu':{z:'North',c:'B'},
  'Jaipur':{z:'North',c:'B'},'Kanpur':{z:'North',c:'B'},'Lucknow':{z:'North',c:'B'},
  'Ludhiana':{z:'North',c:'B'},'Patiala':{z:'North',c:'B'},'Srinagar':{z:'North',c:'B'},
  'Shimla':{z:'North',c:'B'},'Simla':{z:'North',c:'B'},'Varanasi':{z:'North',c:'B'},
  'Noida':{z:'North',c:'B'},'Faridabad':{z:'North',c:'B'},'Gurugram':{z:'North',c:'B'},
  // West
  'Mumbai':{z:'West',c:'Super A'},'Bombay':{z:'West',c:'Super A'},
  'Pune':{z:'West',c:'A'},'Ahmedabad':{z:'West',c:'A'},
  'Aurangabad':{z:'West',c:'B'},'Baroda':{z:'West',c:'B'},'Vadodara':{z:'West',c:'B'},
  'Bhopal':{z:'West',c:'B'},'Goa':{z:'West',c:'B'},'Panaji':{z:'West',c:'B'},
  'Gwalior':{z:'West',c:'B'},'Indore':{z:'West',c:'B'},'Jamnagar':{z:'West',c:'B'},
  'Jabalpur':{z:'West',c:'B'},'Kolhapur':{z:'West',c:'B'},'Nasik':{z:'West',c:'B'},
  'Nashik':{z:'West',c:'B'},'Nagpur':{z:'West',c:'B'},'Rajkot':{z:'West',c:'B'},
  'Raipur':{z:'West',c:'B'},'Surat':{z:'West',c:'B'},'Thane':{z:'West',c:'B'},
  // South
  'Chennai':{z:'South',c:'Super A'},'Madras':{z:'South',c:'Super A'},
  'Bangalore':{z:'South',c:'Super A'},'Bengaluru':{z:'South',c:'Super A'},
  'Hyderabad':{z:'South',c:'A'},
  'Cochin':{z:'South',c:'B'},'Kochi':{z:'South',c:'B'},'Coimbatore':{z:'South',c:'B'},
  'Calicut':{z:'South',c:'B'},'Kozhikode':{z:'South',c:'B'},'Madurai':{z:'South',c:'B'},
  'Mysore':{z:'South',c:'B'},'Mysuru':{z:'South',c:'B'},'Mangalore':{z:'South',c:'B'},
  'Trivandrum':{z:'South',c:'B'},'Thiruvananthapuram':{z:'South',c:'B'},
  'Visakhapatnam':{z:'South',c:'B'},'Vizag':{z:'South',c:'B'},'Vijayawada':{z:'South',c:'B'},
  'Tiruchirappalli':{z:'South',c:'B'},'Trichy':{z:'South',c:'B'},
  // East
  'Kolkata':{z:'East',c:'Super A'},'Calcutta':{z:'East',c:'Super A'},
  'Bhubaneswar':{z:'East',c:'A'},'Guwahati':{z:'East',c:'A'},
  'Patna':{z:'East',c:'B'},'Ranchi':{z:'East',c:'B'},'Jamshedpur':{z:'East',c:'B'},
  'Dhanbad':{z:'East',c:'B'},'Cuttack':{z:'East',c:'B'},'Siliguri':{z:'East',c:'B'},
  'Rourkela':{z:'East',c:'B'},'Agartala':{z:'East',c:'B'},'Dibrugarh':{z:'East',c:'B'},
  'Shillong':{z:'East',c:'B'},'Imphal':{z:'East',c:'C'},
};

const LODGING_CAPS = {
  'JM1-JM2':{'Super A':{flat:650,actual:1700,inc:125},'A':{flat:550,actual:1500,inc:125},'B':{flat:500,actual:1300,inc:125},'C':{flat:450,actual:1200,inc:125}},
  'JM3-JM4':{'Super A':{flat:700,actual:2000,inc:125},'A':{flat:650,actual:1800,inc:125},'B':{flat:600,actual:1600,inc:125},'C':{flat:550,actual:1400,inc:125}},
  'JM5+'    :{'Super A':{flat:1000,actual:3000,inc:0},'A':{flat:750,actual:2800,inc:0},'B':{flat:700,actual:2500,inc:0},'C':{flat:650,actual:2000,inc:0}},
};
function grpGrade(g){if(g==='JM1'||g==='JM2')return'JM1-JM2';if(g==='JM3'||g==='JM4')return'JM3-JM4';return'JM5+';}
function getCap(grade,cls){const grp=grpGrade(grade);return LODGING_CAPS[grp][cls]||LODGING_CAPS[grp]['C'];}
function classColor(c){return{' Super A':'cls-sa','Super A':'cls-sa','A':'cls-a','B':'cls-b','C':'cls-c'}[c]||'cls-c';}

// Trips state
let trips = JSON.parse(localStorage.getItem('hh3_trips')||'{}');
// conveyance toggles stored in att as \`\${empId}_\${y}_\${m}_\${d}_conv\` = 0 or 1

function saveTrips(){try{localStorage.setItem('hh3_trips',JSON.stringify(trips));}catch(e){}}

function getMonthTrips(y,m){
  const res=[];
  Object.keys(trips).forEach(k=>{
    if(k.endsWith(\`_\${y}_\${m}\`))res.push(...(trips[k]||[]));
  });
  return res;
}
function addTripToState(empId,y,m,trip){
  const k=\`\${empId}_\${y}_\${m}\`;
  if(!trips[k])trips[k]=[];
  trip.id='t'+Date.now();
  trips[k].push(trip);
  saveTrips();
}
function deleteTripFromState(empId,y,m,tripId){
  const k=\`\${empId}_\${y}_\${m}\`;
  if(trips[k])trips[k]=trips[k].filter(t=>t.id!==tripId);
  saveTrips();
}

// ══════════════════════════════════════════════════════════════
// PATCH renderAtt — add conveyance toggles
// ══════════════════════════════════════════════════════════════
function calcConvTotal(emp,y,m){
  let total=0;
  const days2=daysIn(y,m);
  for(let d=1;d<=days2;d++){
    const s=att[\`\${emp.id}_\${y}_\${m}_\${d}\`];
    if((s==='P'||s==='HD')&&att[\`\${emp.id}_\${y}_\${m}_\${d}_conv\`]!==0){
      total+=s==='HD'?125:250;
    }
  }
  return total;
}

// Patch the original renderAtt to include conveyance
const _origRenderAtt = renderAtt;
renderAtt = function(){
  const days=daysIn(curYear,curMonth);
  function getS(empId,d){
    const s=att[\`\${empId}_\${curYear}_\${curMonth}_\${d}\`];
    return s||(new Date(curYear,curMonth-1,d).getDay()===0?'WO':null);
  }
  const legend=SC.map(s=>{const st=ST[s];return\`<div class="legend-item"><div class="legend-badge s-\${s}">\${s}</div>\${st.l}</div>\`;}).join('');
  let dayHdrs='';
  for(let d=1;d<=days;d++){const dow=new Date(curYear,curMonth-1,d).getDay();dayHdrs+=\`<th style="\${dow===0?'background:#4b5563;':''}">\${d}<br><span style="font-size:8px;">\${DS[dow]}</span></th>\`;}

  let empRows=emps.map((emp,ei)=>{
    const cntMap={P:0,A:0,HD:0,H:0,WO:0,CL:0,SL:0,EL:0,unm:0};
    let totalVisits=0,totalConv=0;
    let cells='';
    for(let d=1;d<=days;d++){
      const s=getS(emp.id,d);
      const dow=new Date(curYear,curMonth-1,d).getDay();
      const visits=Number(att[\`\${emp.id}_\${curYear}_\${curMonth}_\${d}_v\`]||0);
      if(visits>0)totalVisits+=visits;
      const convKey=\`\${emp.id}_\${curYear}_\${curMonth}_\${d}_conv\`;
      const canClaim=s==='P'||s==='HD';
      const convOn=canClaim&&att[convKey]!==0; // default ON for P/HD
      const convAmt=s==='P'?250:s==='HD'?125:0;
      if(convOn&&canClaim)totalConv+=convAmt;
      if(s){
        const st=ST[s];
        if(cntMap[s]!==undefined)cntMap[s]++;
        const visitInput=canClaim?\`<input type="number" min="0" max="99" class="visit-input" value="\${visits||''}" placeholder="0" title="Visits on \${d}" onchange="setVisit('\${emp.id}',\${d},this.value)" onclick="event.stopPropagation()">\`:
          \`<div style="width:28px;height:14px;"></div>\`;
        const convBtn=canClaim?\`<button class="conv-btn \${convOn?'conv-on':'conv-off'}" onclick="toggleConv('\${emp.id}',\${d})" title="Daily conveyance ₹\${convAmt} — click to toggle">\${convOn?'₹'+convAmt:'—'}</button>\`:
          \`<div style="width:28px;height:13px;"></div>\`;
        cells+=\`<td style="\${dow===0?'background:#f8f8f8;':''}"><div class="att-cell-wrap"><button class="att-btn s-\${s}" onclick="cycleAtt('\${emp.id}',\${d})" title="\${st.l}">\${s}</button>\${visitInput}\${convBtn}</div></td>\`;
      } else {
        cntMap.unm++;
        cells+=\`<td><div class="att-cell-wrap"><button class="att-empty" onclick="setAttS('\${emp.id}',\${d},'P')" title="Click to mark Present">+</button><div style="width:28px;height:14px;"></div><div style="width:28px;height:13px;"></div></div></td>\`;
      }
    }
    const lopD=cntMap.A+cntMap.HD*0.5+cntMap.unm;
    const wd=wdCount(curYear,curMonth);
    const tgt=(emp.visitTarget||12)*(cntMap.P||0);
    const visitColor=totalVisits>=tgt?'var(--green)':(totalVisits>0?'var(--orange)':'var(--subtext)');
    return\`<tr>
      <td class="att-emp-cell">
        <div class="att-emp-name">\${emp.name}</div>
        <div class="att-emp-grade">\${GRADES[emp.grade]||emp.grade} | \${emp.visitTarget||12}/day</div>
        <div style="font-size:9px;color:var(--orange);margin-top:1px;">Conv: \${INR(totalConv)}</div>
        <button class="muster-btn" style="margin-top:3px;" onclick="downloadMuster('\${emp.id}')">📄 PDF Muster</button>
      </td>
      \${cells}
      <td class="att-sum text-green">\${cntMap.P}</td>
      <td class="att-sum" style="color:\${lopD>0?'var(--red)':'#bbb'};">\${lopD}</td>
      <td class="att-sum" style="color:\${visitColor};font-weight:700;">\${totalVisits}<br><span style="font-size:8px;color:var(--subtext);">/\${tgt}</span></td>
      <td class="att-sum" style="color:var(--orange);font-weight:700;">\${INR(totalConv)}</td>
      <td class="att-sum text-sub">\${wd}</td>
    </tr>\`;
  }).join('');

  // Outstation section
  const outstationHtml = renderOutstationSection();

  document.getElementById('attendance').innerHTML=\`
    <div class="page-hdr">
      <h2>Attendance — \${MONTHS[curMonth-1]} \${curYear}</h2>
      <div style="display:flex;gap:8px;align-items:center;">\${mnav()}
        <button class="btn btn-green btn-sm" onclick="markAllPresent()"><i class="ti ti-check"></i> Mark all present</button>
        <button class="btn btn-primary btn-sm" onclick="emps.forEach(e=>downloadMuster(e.id))"><i class="ti ti-download"></i> Download All</button>
      </div>
    </div>
    <div class="legend">\${legend}
      <div class="legend-item" style="gap:4px;"><div class="conv-btn conv-on" style="cursor:default;">₹250</div>= Daily conveyance claimed</div>
      <div class="legend-item"><div class="conv-btn conv-off" style="cursor:default;">—</div>= Not claimed / transit</div>
      <span style="font-size:11px;color:#aaa;margin-left:4px;">Click status to cycle · Enter number for visits · Click ₹ to toggle conveyance</span>
    </div>
    <div class="card mb">
      <div class="card-head"><h3>Daily attendance & conveyance tracker</h3></div>
      <div class="att-wrap">
        <table class="att-table">
          <thead><tr>
            <th style="text-align:left;min-width:145px;position:sticky;left:0;z-index:10;">Employee</th>
            \${dayHdrs}
            <th>Pres.</th><th>LOP</th><th style="color:#ffd700;">Visits</th><th style="color:#86efac;">Conv.</th><th>WDays</th>
          </tr></thead>
          <tbody>\${empRows}</tbody>
        </table>
      </div>
    </div>
    \${outstationHtml}\`;
};

function toggleConv(empId,d){
  const k=\`\${empId}_\${curYear}_\${curMonth}_\${d}_conv\`;
  const s=att[\`\${empId}_\${curYear}_\${curMonth}_\${d}\`];
  const defaultOn=(s==='P'||s==='HD');
  const curr=att[k]===undefined?defaultOn:att[k]!==0;
  att[k]=curr?0:1;
  save('hh3_att',att);
  renderAtt();
}

// ══════════════════════════════════════════════════════════════
// OUTSTATION TRAVEL SECTION
// ══════════════════════════════════════════════════════════════
function renderOutstationSection(){
  const monthTrips=[];
  emps.forEach(emp=>{
    const k=\`\${emp.id}_\${curYear}_\${curMonth}\`;
    (trips[k]||[]).forEach(t=>monthTrips.push({...t,emp}));
  });

  const empOpts=emps.map(e=>\`<option value="\${e.id}">\${e.name} (\${e.grade})</option>\`).join('');
  const cityList=Object.keys(CITY_CLASS_MAP).map(c=>\`<option value="\${c}">\`).join('');

  let tripCards='';
  if(monthTrips.length===0){
    tripCards=\`<div style="text-align:center;padding:32px;color:var(--subtext);">
      <i class="ti ti-map-2" style="font-size:32px;margin-bottom:8px;display:block;opacity:0.4;"></i>
      No outstation trips recorded for \${MONTHS[curMonth-1]} \${curYear}.<br>
      <span style="font-size:11px;">Click "Add Outstation Trip" to log a trip with lodging and travel expenses.</span>
    </div>\`;
  } else {
    tripCards=monthTrips.map(t=>{
      const cap=getCap(t.emp.grade,t.cityClass||'C');
      const nights=t.nights||0;
      const lodgingCap=(t.lodgingMode==='flat'?cap.flat:cap.actual)*nights;
      const policyTotal=lodgingCap+cap.inc*nights+t.conveyanceDays*250+(t.resConv?250:0);
      const claimed=t.totalClaimed||0;
      const diff=claimed-policyTotal;
      const status=diff<=0?'ok':(diff<=500?'warn':'over');
      const statusLabel=status==='ok'?'✅ Within policy':(status==='warn'?'⚠️ Slightly over':'🔴 Exceeds policy');
      const statusCls='trip-'+status;
      const cls=t.cityClass||'C';
      return\`<div class="trip-card">
        <div class="trip-card-head">
          <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
            <div class="initials" style="width:28px;height:28px;font-size:10px;">\${initials(t.emp.name)}</div>
            <div>
              <div style="font-weight:700;font-size:13px;">\${t.emp.name} <span style="font-size:11px;color:var(--subtext);">— \${t.emp.grade}</span></div>
              <div style="font-size:11px;color:var(--subtext);">\${t.fromDate} to \${t.toDate} · \${t.nights} nights</div>
            </div>
            <div class="city-chip">\${t.city||'—'}</div>
            <span class="class-chip \${classColor(cls)}">\${cls}</span>
            <span style="font-size:11px;color:var(--subtext);">\${t.zone||'—'} Zone</span>
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <span class="trip-badge \${statusCls}">\${statusLabel}</span>
            <button class="btn btn-sm btn-del" onclick="deleteTrip('\${t.emp.id}','\${t.id}')" title="Delete this trip"><i class="ti ti-trash"></i></button>
          </div>
        </div>
        <div style="display:grid;grid-template-columns:repeat(5,1fr);gap:8px;font-size:11px;background:var(--gray);border-radius:6px;padding:10px 12px;">
          \${[
            ['Mode',t.travelMode||'—',''],
            ['Lodging mode',t.lodgingMode==='flat'?'Flat rate':'Actuals',''],
            ['Lodging/night',INR(t.lodgingPerNight||0),''],
            ['Daily conv.',\`\${t.conveyanceDays} days × ₹250\`,'color:var(--orange);'],
            ['Other exp.',INR(t.otherExp||0),''],
          ].map(([l,v,st])=>\`<div><div style="color:var(--subtext);margin-bottom:2px;">\${l}</div><div style="font-weight:600;\${st}">\${v}</div></div>\`).join('')}
        </div>
        <div class="policy-box">
          <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr 1fr;gap:8px;font-size:11px;">
            \${[
              ['Policy cap/night',INR(t.lodgingMode==='flat'?cap.flat:cap.actual),''],
              ['Lodging cap total',INR(lodgingCap),''],
              ['Incidental total',INR(cap.inc*nights),''],
              ['Conveyance',INR(t.conveyanceDays*250+(t.resConv?250:0)),''],
              ['Policy total',INR(policyTotal),'font-weight:700;color:var(--navy);'],
            ].map(([l,v,st])=>\`<div class="policy-row" style="display:block;"><div style="margin-bottom:2px;">\${l}</div><div style="font-weight:600;\${st}">\${v}</div></div>\`).join('')}
          </div>
          <div style="border-top:1px solid var(--border);margin-top:8px;padding-top:8px;display:flex;justify-content:space-between;align-items:center;">
            <div style="font-size:12px;"><span style="color:var(--subtext);">Total claimed: </span><b style="color:var(--navy);">\${INR(claimed)}</b></div>
            <div style="font-size:12px;"><span style="color:var(--subtext);">vs policy cap: </span><b style="color:\${diff>0?'var(--red)':'var(--green)'};">\${diff>0?'+'+INR(diff):'-'+INR(Math.abs(diff))}</b></div>
          </div>
        </div>
      </div>\`;
    }).join('');
  }

  // Monthly conveyance + outstation summary
  const dailyConvTotal=emps.reduce((a,e)=>a+calcConvTotal(e,curYear,curMonth),0);
  const outstationTotal=monthTrips.reduce((a,t)=>a+(t.totalClaimed||0),0);

  return\`<div class="card">
    <div class="card-head">
      <h3><i class="ti ti-plane" style="font-size:13px;"></i> Outstation Travel Log — \${MONTHS[curMonth-1]} \${curYear}</h3>
      <button class="btn btn-orange btn-sm" onclick="openTripModal()"><i class="ti ti-plus"></i> Add Outstation Trip</button>
    </div>
    <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px;padding:14px 16px;background:var(--gray);border-bottom:1px solid var(--border);">
      <div><div class="stat-lbl">Daily conveyance total</div><div style="font-size:18px;font-weight:700;color:var(--orange);">\${INR(dailyConvTotal)}</div><div class="stat-sub">All employees this month</div></div>
      <div><div class="stat-lbl">Outstation expenses claimed</div><div style="font-size:18px;font-weight:700;color:var(--navy);">\${INR(outstationTotal)}</div><div class="stat-sub">\${monthTrips.length} trips this month</div></div>
      <div><div class="stat-lbl">Total reimbursables</div><div style="font-size:18px;font-weight:700;color:var(--green);">\${INR(dailyConvTotal+outstationTotal)}</div><div class="stat-sub">Daily conv. + outstation</div></div>
    </div>
    <div style="padding:14px 16px;">\${tripCards}</div>
  </div>

  <!-- Outstation Trip Modal -->
  <div id="trip-modal" class="modal-bg" style="display:none;" onclick="if(event.target===this)closeTripModal()">
    <div class="modal trip-modal">
      <div class="modal-head"><h3>Add Outstation Trip</h3>
        <button class="btn btn-sm" style="color:#fff;border-color:rgba(255,255,255,0.3);" onclick="closeTripModal()"><i class="ti ti-x"></i></button>
      </div>
      <div class="modal-body">
        <div class="form-section-title"><i class="ti ti-user" style="font-size:12px;"></i> Trip Details</div>
        <div class="form-row">
          <div class="form-group"><label>Employee</label>
            <select id="t-emp" onchange="tripEmpChanged()">\${empOpts}</select>
          </div>
          <div class="form-group"><label>Travel mode (auto from grade)</label>
            <select id="t-mode">
              <option value="Sleeper/3AC Train">Sleeper / 3AC Train</option>
              <option value="AC Bus">AC Bus</option>
              <option value="3AC Train">3AC Train</option>
              <option value="2AC Train">2AC Train</option>
              <option value="Flight (Economy)">Flight (Economy)</option>
              <option value="Own Vehicle">Own Vehicle</option>
            </select>
          </div>
        </div>
        <div class="form-3col">
          <div class="form-group"><label>From date</label><input id="t-from" type="date" oninput="calcTripNights()"></div>
          <div class="form-group"><label>To date</label><input id="t-to" type="date" oninput="calcTripNights()"></div>
          <div class="form-group"><label>No. of nights (auto)</label><input id="t-nights" type="number" min="0" value="0" oninput="calcTripPolicy()"></div>
        </div>
        <div class="form-section-title" style="margin-top:6px;"><i class="ti ti-building-skyscraper" style="font-size:12px;"></i> City & Classification</div>
        <datalist id="city-list">\${''.concat(...Object.keys(CITY_CLASS_MAP).map(c=>\`<option value="\${c}"\`+'>'))}</datalist>
        <div class="form-3col">
          <div class="form-group"><label>City visited</label>
            <input id="t-city" list="city-list" placeholder="Type city name…" oninput="cityAutoFill()">
          </div>
          <div class="form-group"><label>Zone</label>
            <select id="t-zone" onchange="calcTripPolicy()">
              <option value="">-- Auto / Select --</option>
              <option value="North">North</option>
              <option value="West">West</option>
              <option value="South">South</option>
              <option value="East">East</option>
            </select>
          </div>
          <div class="form-group"><label>City classification</label>
            <select id="t-class" onchange="calcTripPolicy()">
              <option value="C">C — All other towns</option>
              <option value="B">B — Major city</option>
              <option value="A">A — Metro class</option>
              <option value="Super A">Super A — Top metro</option>
            </select>
          </div>
        </div>
        <!-- Policy cap display -->
        <div id="trip-policy-bar" class="cap-bar" style="margin-bottom:12px;">
          <div class="cap-item"><div class="cap-lbl">Grade group</div><div id="cp-grade" class="cap-val" style="font-size:12px;">—</div></div>
          <div class="cap-item"><div class="cap-lbl">Lodging flat rate/night</div><div id="cp-flat" class="cap-val" style="color:var(--orange);">—</div></div>
          <div class="cap-item"><div class="cap-lbl">Lodging actuals/night</div><div id="cp-actual" class="cap-val" style="color:var(--blue);">—</div></div>
          <div class="cap-item"><div class="cap-lbl">Incidental/night</div><div id="cp-inc" class="cap-val">—</div></div>
        </div>
        <div class="form-section-title"><i class="ti ti-bed" style="font-size:12px;"></i> Lodging & Expenses</div>
        <div class="form-row">
          <div class="form-group"><label>Lodging option</label>
            <select id="t-lodging-mode" onchange="calcTripPolicy()">
              <option value="flat">Flat rate (no bills required)</option>
              <option value="actual">Actuals (bills required)</option>
            </select>
          </div>
          <div class="form-group"><label>Amount per night (₹)</label>
            <input id="t-lodging-amt" type="number" min="0" placeholder="Amount per night" oninput="calcTripPolicy()">
          </div>
        </div>
        <div class="form-section-title"><i class="ti ti-car" style="font-size:12px;"></i> Conveyance</div>
        <div class="form-row">
          <div class="form-group">
            <label>Market working days during trip</label>
            <input id="t-conv-days" type="number" min="0" value="0" placeholder="Days in market" oninput="calcTripPolicy()">
            <div style="font-size:10px;color:var(--subtext);margin-top:3px;">₹250/day for JM1–JM4 for days actually worked in market</div>
          </div>
          <div class="form-group">
            <label>Residence ↔ station (₹125 each way)</label>
            <select id="t-res-conv" onchange="calcTripPolicy()">
              <option value="0">Not claimed</option>
              <option value="125">Departure only — ₹125</option>
              <option value="250">Both departure + return — ₹250</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group"><label>Other / miscellaneous expenses (₹)</label>
            <input id="t-other" type="number" min="0" placeholder="0" oninput="calcTripPolicy()">
          </div>
          <div class="form-group"><label>Total expense incurred (₹) — actual spend</label>
            <input id="t-actual-total" type="number" min="0" placeholder="Total actual spend" oninput="calcTripPolicy()">
          </div>
        </div>
        <!-- Summary -->
        <div id="trip-summary" style="background:var(--lnavy);border-radius:10px;padding:14px 16px;margin-top:4px;">
          <div style="font-size:12px;font-weight:700;color:var(--navy);margin-bottom:10px;"><i class="ti ti-calculator"></i> Reimbursement Summary</div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;font-size:12px;">
            <div>
              <div style="font-weight:700;margin-bottom:6px;color:var(--subtext);font-size:10px;text-transform:uppercase;">CLAIMED (as per policy)</div>
              <div id="sum-lodging-claimed" class="policy-row">Lodging claimed: <span>—</span></div>
              <div id="sum-conv-claimed" class="policy-row">Conveyance: <span>—</span></div>
              <div id="sum-other-claimed" class="policy-row">Other expenses: <span>—</span></div>
              <div class="policy-total policy-row" style="margin-top:6px;">Total to claim: <span id="sum-total-claimed">—</span></div>
            </div>
            <div>
              <div style="font-weight:700;margin-bottom:6px;color:var(--subtext);font-size:10px;text-transform:uppercase;">POLICY CAPS</div>
              <div id="sum-lodging-cap" class="policy-row">Max lodging (nights): <span>—</span></div>
              <div id="sum-inc-cap" class="policy-row">Incidental (nights): <span>—</span></div>
              <div id="sum-conv-cap" class="policy-row">Conveyance cap: <span>—</span></div>
              <div class="policy-total policy-row" style="margin-top:6px;">Total policy cap: <span id="sum-cap-total">—</span></div>
            </div>
          </div>
          <div id="sum-status" style="margin-top:10px;text-align:center;font-size:13px;font-weight:700;padding:6px;border-radius:6px;">
            Fill in trip details to see status
          </div>
        </div>
        <div id="trip-notes" style="display:none;background:var(--lamber);border-radius:6px;padding:8px 12px;margin-top:8px;font-size:11px;color:var(--amber);"></div>
      </div>
      </div>
      <div class="modal-foot">
        <button class="btn" onclick="closeTripModal()">Cancel</button>
        <button class="btn btn-primary" onclick="saveTrip()"><i class="ti ti-check"></i> Save Trip</button>
      </div>
    </div>
  </div>\`;
}

function openTripModal(){
  document.getElementById('trip-modal').style.display='flex';
  tripEmpChanged();
}
function closeTripModal(){document.getElementById('trip-modal').style.display='none';}

function tripEmpChanged(){
  const empId=document.getElementById('t-emp')?.value;
  const emp=emps.find(e=>e.id===empId);
  if(!emp)return;
  // Auto-set travel mode by grade
  const modeEl=document.getElementById('t-mode');
  if(modeEl){
    if(emp.grade==='JM1'||emp.grade==='JM2')modeEl.value='Sleeper/3AC Train';
    else if(emp.grade==='JM3')modeEl.value='3AC Train';
    else if(emp.grade==='JM4')modeEl.value='2AC Train';
    else modeEl.value='Flight (Economy)';
  }
  calcTripPolicy();
}

function cityAutoFill(){
  const city=document.getElementById('t-city')?.value||'';
  const info=CITY_CLASS_MAP[city];
  if(info){
    const zoneEl=document.getElementById('t-zone');
    const clsEl=document.getElementById('t-class');
    if(zoneEl)zoneEl.value=info.z;
    if(clsEl)clsEl.value=info.c;
  }
  calcTripPolicy();
}

function calcTripNights(){
  const from=document.getElementById('t-from')?.value;
  const to=document.getElementById('t-to')?.value;
  if(from&&to){
    const d1=new Date(from),d2=new Date(to);
    const nights=Math.max(0,Math.round((d2-d1)/(1000*60*60*24)));
    const el=document.getElementById('t-nights');
    if(el)el.value=nights;
    const cd=document.getElementById('t-conv-days');
    if(cd&&cd.value==='0')cd.value=nights;
  }
  calcTripPolicy();
}

function calcTripPolicy(){
  const empId=document.getElementById('t-emp')?.value;
  const emp=emps.find(e=>e.id===empId);
  const cls=document.getElementById('t-class')?.value||'C';
  const nights=Number(document.getElementById('t-nights')?.value||0);
  const lodgingMode=document.getElementById('t-lodging-mode')?.value||'flat';
  const lodgingAmt=Number(document.getElementById('t-lodging-amt')?.value||0);
  const convDays=Number(document.getElementById('t-conv-days')?.value||0);
  const resConv=Number(document.getElementById('t-res-conv')?.value||0);
  const other=Number(document.getElementById('t-other')?.value||0);
  if(!emp)return;

  const cap=getCap(emp.grade,cls);
  const grp=grpGrade(emp.grade);
  const capPerNight=lodgingMode==='flat'?cap.flat:cap.actual;

  // Update policy bar
  const cpGrade=document.getElementById('cp-grade');
  const cpFlat=document.getElementById('cp-flat');
  const cpActual=document.getElementById('cp-actual');
  const cpInc=document.getElementById('cp-inc');
  if(cpGrade)cpGrade.textContent=grp;
  if(cpFlat)cpFlat.textContent=INR(cap.flat);
  if(cpActual)cpActual.textContent=INR(cap.actual);
  if(cpInc)cpInc.textContent=cap.inc>0?INR(cap.inc):grp==='JM5+'?'Nil':INR(cap.inc);

  const lodgingClaimed=Math.min(lodgingAmt,capPerNight)*nights;
  const convTotal=convDays*250+resConv;
  const totalClaimed=lodgingClaimed+convTotal+other;
  const lodgingCap=capPerNight*nights;
  const incCap=cap.inc*nights;
  const capTotal=lodgingCap+incCap+convTotal;

  // Update summary rows
  const setRow=(id,label,val)=>{
    const el=document.getElementById(id);
    if(el)el.innerHTML=\`\${label}: <span style="font-weight:600;">\${INR(val)}</span>\`;
  };
  setRow('sum-lodging-claimed',\`Lodging (\${nights}n × \${INR(Math.min(lodgingAmt,capPerNight))})\`,lodgingClaimed);
  setRow('sum-conv-claimed','Conveyance',convTotal);
  setRow('sum-other-claimed','Other',other);
  const tc=document.getElementById('sum-total-claimed');
  if(tc){tc.textContent=INR(totalClaimed);tc.style.color='var(--navy)';}
  setRow('sum-lodging-cap',\`Lodging cap (\${nights}n × \${INR(capPerNight)})\`,lodgingCap);
  setRow('sum-inc-cap',\`Incidental (\${nights}n × \${INR(cap.inc)})\`,incCap);
  setRow('sum-conv-cap','Conveyance allowance',convTotal);
  const ct=document.getElementById('sum-cap-total');
  if(ct){ct.textContent=INR(capTotal);ct.style.color='var(--navy)';}

  const diff=totalClaimed-capTotal;
  const status=document.getElementById('sum-status');
  if(status){
    if(totalClaimed===0){status.style.background='var(--gray)';status.style.color='var(--subtext)';status.textContent='Fill in trip details to see status';}
    else if(diff<=0){status.style.background='var(--lgreen)';status.style.color='var(--green)';status.textContent=\`✅ Within policy — \${INR(Math.abs(diff))} under cap\`;}
    else if(diff<=1000){status.style.background="#FFF3CD"||'#FFF3CD';status.style.color='var(--amber)';status.textContent=\`⚠️ Slightly over — exceeds cap by \${INR(diff)} (needs approval)\`;}
    else{status.style.background='var(--lred)';status.style.color='var(--red)';status.textContent=\`🔴 Exceeds policy cap by \${INR(diff)} — prior written approval required\`;}
  }

  const notes=document.getElementById('trip-notes');
  const noteArr=[];
  if(lodgingMode==='actual')noteArr.push('📋 Actuals mode: Original hotel bills with company GST (24AARFH4921J1Z5) required.');
  if(emp.grade==='JM4')noteArr.push('ℹ️ 2AC travel requires prior written approval from management.');
  if(resConv>0)noteArr.push('🏠 Res-to-station allowance claimable only if 6+ hours worked in market on same day.');
  if(notes){notes.style.display=noteArr.length?'block':'none';notes.innerHTML=noteArr.join('<br>');}
}

function saveTrip(){
  const empId=document.getElementById('t-emp')?.value;
  const emp=emps.find(e=>e.id===empId);
  const from=document.getElementById('t-from')?.value;
  const to=document.getElementById('t-to')?.value;
  const city=document.getElementById('t-city')?.value?.trim();
  if(!emp||!from||!to||!city){alert('Employee, dates and city are required.');return;}
  const cls=document.getElementById('t-class')?.value||'C';
  const nights=Number(document.getElementById('t-nights')?.value||0);
  const lodgingMode=document.getElementById('t-lodging-mode')?.value||'flat';
  const lodgingPerNight=Number(document.getElementById('t-lodging-amt')?.value||0);
  const conveyanceDays=Number(document.getElementById('t-conv-days')?.value||0);
  const resConv=Number(document.getElementById('t-res-conv')?.value||0);
  const otherExp=Number(document.getElementById('t-other')?.value||0);
  const actualTotal=Number(document.getElementById('t-actual-total')?.value||0);
  const cap=getCap(emp.grade,cls);
  const capPerNight=lodgingMode==='flat'?cap.flat:cap.actual;
  const lodgingClaimed=Math.min(lodgingPerNight,capPerNight)*nights;
  const convTotal=conveyanceDays*250+resConv;
  const totalClaimed=lodgingClaimed+convTotal+otherExp;
  const trip={
    fromDate:from,toDate:to,city,zone:document.getElementById('t-zone')?.value||'',
    cityClass:cls,travelMode:document.getElementById('t-mode')?.value||'',
    lodgingMode,lodgingPerNight,nights,conveyanceDays,resConv,otherExp,actualTotal,totalClaimed,
  };
  addTripToState(empId,curYear,curMonth,trip);
  closeTripModal();
  renderAtt();
}

function deleteTrip(empId,tripId){
  if(!confirm('Delete this trip record?'))return;
  deleteTripFromState(empId,curYear,curMonth,tripId);
  renderAtt();
}


// ── SALARY FILTER STATE ───────────────────────────────────────
let salFilterId = null;

function setSalFilter(id) {
  salFilterId = (salFilterId === id) ? null : id;
  renderSal();
}

// ── OUTSTATION EXPENSE TOTALS ─────────────────────────────────
function getEmpOutstationTotal(empId, y, m) {
  const k = \`\${empId}_\${y}_\${m}\`;
  return (trips[k] || []).reduce((a, t) => a + (t.totalClaimed || 0), 0);
}
function getEmpTripCount(empId, y, m) {
  const k = \`\${empId}_\${y}_\${m}\`;
  return (trips[k] || []).length;
}

// ── ATTENDANCE MUSTER PDF ─────────────────────────────────────
function downloadMuster(empId) {
  const emp = emps.find(e => e.id === empId);
  if (!emp) return;
  const html = buildMusterHTML(emp, curYear, curMonth);
  const win = window.open('', '_blank');
  if (!win) { alert('Allow popups for this page to download the muster report.'); return; }
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); }, 600);
}

function buildMusterHTML(emp, y, m) {
  const MONTHS_F = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const DAY_FULL = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const DAY_S    = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  const STATUS_LABELS = {P:'Present',A:'Absent (LOP)',HD:'Half Day',H:'Holiday',WO:'Week Off',CL:'Casual Leave',SL:'Sick Leave',EL:'Earned Leave'};
  const STATUS_COLORS = {P:'#166534',A:'#991b1b',HD:'#9a3412',H:'#5b21b6',WO:'#475569',CL:'#1e40af',SL:'#854d0e',EL:'#065f46'};
  const STATUS_BG     = {P:'#dcfce7',A:'#fee2e2',HD:'#ffedd5',H:'#ede9fe',WO:'#f1f5f9',CL:'#dbeafe',SL:'#fef9c3',EL:'#ccfbf1'};

  const totalDays = new Date(y, m, 0).getDate();
  const wdays = wdCount(y, m);
  const sal = calcComp(emp.ctc, emp.ta, emp.special, emp.mobile, emp.pfRate, emp.esicApplicable);

  // Build daily data
  let dailyRows = '';
  const cnt = {P:0,A:0,HD:0,H:0,WO:0,CL:0,SL:0,EL:0};
  let totalVisits = 0, totalConv = 0, lopDays = 0;

  for (let d = 1; d <= totalDays; d++) {
    const dateObj = new Date(y, m-1, d);
    const dow = dateObj.getDay();
    const s = att[\`\${emp.id}_\${y}_\${m}_\${d}\`] || (dow === 0 ? 'WO' : '');
    const sLabel = STATUS_LABELS[s] || '—';
    const sBg = s ? STATUS_BG[s] : '#fff';
    const sColor = s ? STATUS_COLORS[s] : '#888';
    if (s && cnt[s] !== undefined) cnt[s]++;
    const visits = Number(att[\`\${emp.id}_\${y}_\${m}_\${d}_v\`] || 0);
    if (visits > 0) totalVisits += visits;
    const canClaim = s === 'P' || s === 'HD';
    const convOn = canClaim && att[\`\${emp.id}_\${y}_\${m}_\${d}_conv\`] !== 0;
    const convAmt = convOn ? (s === 'P' ? 250 : 125) : 0;
    totalConv += convAmt;
    if (s === 'A') lopDays++;
    else if (s === 'HD') lopDays += 0.5;

    const dateStr = String(d).padStart(2,'0') + ' ' + MONTHS_F[m-1].slice(0,3) + ' ' + y;
    const isWknd = dow === 0 || dow === 6;
    dailyRows += \`<tr style="background:\${sBg}20;\${isWknd?'opacity:0.75':''}">
      <td style="text-align:center;font-weight:500;">\${d}</td>
      <td>\${dateStr}</td>
      <td>\${DAY_S[dow]}</td>
      <td style="text-align:center;"><span style="display:inline-block;padding:1px 8px;border-radius:3px;font-size:10px;font-weight:700;background:\${sBg};color:\${sColor};">\${s||'—'}</span></td>
      <td style="text-align:center;">\${sLabel}</td>
      <td style="text-align:center;">\${canClaim&&visits>0?visits:'—'}</td>
      <td style="text-align:center;color:\${convAmt>0?'#1e7c4a':'#888'};">\${convAmt>0?'₹'+convAmt:'—'}</td>
    </tr>\`;
  }

  // Outstation trips
  const empTrips = (trips[\`\${emp.id}_\${y}_\${m}\`] || []);
  let tripRows = '';
  let outstationTotal = 0;
  const LDGCAPS = {
    'JM1-JM2':{'Super A':{flat:650,actual:1700},'A':{flat:550,actual:1500},'B':{flat:500,actual:1300},'C':{flat:450,actual:1200}},
    'JM3-JM4':{'Super A':{flat:700,actual:2000},'A':{flat:650,actual:1800},'B':{flat:600,actual:1600},'C':{flat:550,actual:1400}},
    'JM5+':{'Super A':{flat:1000,actual:3000},'A':{flat:750,actual:2800},'B':{flat:700,actual:2500},'C':{flat:650,actual:2000}},
  };
  function grp(g){return g==='JM1'||g==='JM2'?'JM1-JM2':g==='JM3'||g==='JM4'?'JM3-JM4':'JM5+';}
  empTrips.forEach(t => {
    outstationTotal += (t.totalClaimed || 0);
    const cap = (LDGCAPS[grp(emp.grade)][t.cityClass||'C'] || {flat:450,actual:1200});
    const policyTotal = (t.lodgingMode==='flat'?cap.flat:cap.actual)*(t.nights||0) + (t.conveyanceDays||0)*250 + (t.resConv||0);
    const diff = (t.totalClaimed||0) - policyTotal;
    const statusTxt = diff <= 0 ? '✅ Within policy' : \`⚠️ Exceeds by ₹\${Math.abs(diff).toLocaleString('en-IN')}\`;
    tripRows += \`<tr>
      <td>\${t.fromDate} to \${t.toDate}</td>
      <td><b>\${t.city||'—'}</b></td>
      <td>\${t.zone||'—'} / \${t.cityClass||'—'}</td>
      <td style="text-align:center;">\${t.nights||0} nights</td>
      <td style="text-align:center;">\${t.travelMode||'—'}</td>
      <td style="text-align:center;">\${t.lodgingMode==='flat'?'Flat':'Actuals'}</td>
      <td style="text-align:right;">₹\${(t.totalClaimed||0).toLocaleString('en-IN')}</td>
      <td style="text-align:right;">₹\${policyTotal.toLocaleString('en-IN')}</td>
      <td>\${statusTxt}</td>
    </tr>\`;
  });
  if (!tripRows) tripRows = \`<tr><td colspan="9" style="text-align:center;color:#888;padding:10px;">No outstation trips recorded</td></tr>\`;

  const perDay = sal.gross / wdays;
  const lopDed = Math.round(lopDays * perDay);
  const grossPay = Math.max(0, sal.gross - lopDed);
  const totalReimb = totalConv + outstationTotal;

  return \`<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8">
  <title>Attendance Muster — \${emp.name} — \${MONTHS_F[m-1]} \${y}</title>
  <style>
    *{box-sizing:border-box;margin:0;padding:0;}
    body{font-family:Arial,sans-serif;font-size:11px;color:#222;background:#fff;padding:20px;}
    .hdr{background:#1A3C6E;color:#fff;padding:16px 20px;border-radius:6px 6px 0 0;margin-bottom:0;}
    .hdr h1{font-size:16px;font-weight:700;letter-spacing:0.02em;}
    .hdr .sub{font-size:10px;opacity:0.7;margin-top:2px;}
    .pill{display:inline-block;background:#E8611A;padding:3px 14px;border-radius:20px;font-size:11px;font-weight:700;margin-top:8px;}
    .section{margin-top:14px;}
    .section-title{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#1A3C6E;border-bottom:2px solid #1A3C6E;padding-bottom:3px;margin-bottom:8px;}
    table{width:100%;border-collapse:collapse;font-size:10px;}
    th{background:#1A3C6E;color:#fff;padding:5px 8px;text-align:left;font-weight:500;}
    td{padding:4px 8px;border-bottom:1px solid #eee;vertical-align:middle;}
    .info-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:14px;}
    .info-cell{background:#f5f7fa;border-radius:4px;padding:7px 10px;}
    .info-label{font-size:9px;color:#888;margin-bottom:2px;}
    .info-val{font-size:11px;font-weight:600;color:#1A3C6E;}
    .summary-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-top:12px;}
    .sum-cell{background:#eef3fa;border-radius:4px;padding:8px 10px;text-align:center;}
    .sum-val{font-size:16px;font-weight:700;color:#1A3C6E;}
    .sum-lbl{font-size:9px;color:#666;margin-top:1px;}
    .footer-sign{display:flex;justify-content:space-between;margin-top:28px;padding-top:12px;border-top:1px solid #ddd;}
    .sign-box{text-align:center;width:160px;}
    .sign-line{border-bottom:1px solid #333;height:24px;margin-bottom:4px;}
    .sign-lbl{font-size:9px;color:#666;}
    .note{font-size:9px;color:#888;margin-top:6px;font-style:italic;}
    @media print{body{padding:10px;}}
  
/* KPI / PIP */
.kpi-card{background:#fff;border-radius:12px;border:1px solid var(--border);overflow:hidden;box-shadow:var(--shadow);margin-bottom:14px;}
.kpi-head{background:var(--navy);color:#fff;padding:11px 16px;display:flex;align-items:center;justify-content:space-between;}
.kpi-body{display:grid;grid-template-columns:repeat(4,1fr);border-bottom:1px solid var(--border);}
.kpi-metric{padding:13px 14px;border-right:1px solid var(--border);}
.kpi-metric:last-child{border-right:none;}
.kpi-metric-lbl{font-size:10px;color:var(--subtext);font-weight:600;text-transform:uppercase;letter-spacing:0.04em;margin-bottom:5px;}
.kpi-metric-val{font-size:18px;font-weight:700;color:var(--navy);}
.kpi-metric-target{font-size:10px;color:var(--subtext);margin-top:1px;}
.kpi-bar-wrap{height:6px;background:#eef2f8;border-radius:20px;margin-top:5px;overflow:hidden;}
.kpi-bar{height:100%;border-radius:20px;transition:width 0.4s;}
.rating-pill{padding:4px 12px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block;}
.r1{background:#dcfce7;color:#166534;} .r2{background:#d1fae5;color:#065f46;}
.r3{background:#dbeafe;color:#1e40af;} .r4{background:#fef3c7;color:#92400e;}
.r5{background:#fee2e2;color:#991b1b;}
.pct-ring{width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;border:3px solid;}
.pip-card{background:#fff;border-radius:12px;border:1px solid var(--border);margin-bottom:12px;overflow:hidden;box-shadow:var(--shadow);}
.pip-card.active-pip{border-color:#e8611a;}
.pip-card.pass-pip{border-color:#1e7c4a;}
.pip-card.fail-pip{border-color:#c0392b;}
.pip-head{padding:12px 16px;display:flex;align-items:center;justify-content:space-between;cursor:pointer;}
.pip-body{padding:14px 16px;border-top:1px solid var(--border);}
.pip-target-row{display:flex;gap:8px;align-items:flex-start;padding:6px 0;border-bottom:1px solid #f5f5f5;}
.pip-target-row:last-child{border-bottom:none;}
.pip-badge{padding:3px 10px;border-radius:12px;font-size:10px;font-weight:700;}
.pip-active{background:#fff3e0;color:#e8611a;}
.pip-pass{background:#dcfce7;color:#166534;}
.pip-fail{background:#fee2e2;color:#991b1b;}
.prog-log{background:#fafafa;border-radius:6px;padding:8px 10px;font-size:11px;margin-top:4px;}
.ann-table td{padding:8px 12px;font-size:12px;border-bottom:1px solid #f0f0f0;}
.ann-table th{padding:8px 12px;font-size:11px;font-weight:600;color:var(--subtext);}
.input-sm{padding:5px 8px;font-size:12px;border-radius:6px;border:1px solid var(--border);background:#fff;font-family:inherit;color:var(--text);}
.input-sm:focus{outline:none;border-color:var(--navy);}
</style></head><body>
  <div class="hdr">
    <h1>HAPPY HANDS GLOBAL LLP</h1>
    <div class="sub">Plot No.12, TD Industrial Estate, Changodar, Ahmedabad – 382213 | GST: 24AARFH4921J1Z5</div>
    <div class="pill">ATTENDANCE MUSTER — \${MONTHS_F[m-1].toUpperCase()} \${y}</div>
  </div>

  <div class="section">
    <div class="section-title">Employee Information</div>
    <div class="info-grid">
      <div class="info-cell"><div class="info-label">Employee Name</div><div class="info-val">\${emp.name}</div></div>
      <div class="info-cell"><div class="info-label">Employee ID</div><div class="info-val">\${emp.id}</div></div>
      <div class="info-cell"><div class="info-label">Designation</div><div class="info-val">\${emp.designation||emp.grade}</div></div>
      <div class="info-cell"><div class="info-label">Grade</div><div class="info-val">\${emp.grade}</div></div>
      <div class="info-cell"><div class="info-label">Territory</div><div class="info-val">\${emp.territory||'—'}</div></div>
      <div class="info-cell"><div class="info-label">Pay Period</div><div class="info-val">\${MONTHS_F[m-1]} \${y}</div></div>
      <div class="info-cell"><div class="info-label">Working Days in Month</div><div class="info-val">\${wdays}</div></div>
      <div class="info-cell"><div class="info-label">Monthly CTC</div><div class="info-val">₹\${emp.ctc.toLocaleString('en-IN')}</div></div>
    </div>
  </div>

  <div class="section">
    <div class="section-title">Daily Attendance Record</div>
    <table>
      <thead><tr><th style="width:28px">#</th><th>Date</th><th>Day</th><th style="width:42px">Code</th><th>Status</th><th style="width:55px">Visits</th><th style="width:80px">Conveyance</th></tr></thead>
      <tbody>\${dailyRows}</tbody>
    </table>
  </div>

  <div class="section" style="margin-top:16px;">
    <div class="section-title">Monthly Attendance Summary</div>
    <div class="summary-grid">
      <div class="sum-cell"><div class="sum-val">\${wdays}</div><div class="sum-lbl">Working Days</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#166534;">\${cnt.P}</div><div class="sum-lbl">Present</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#991b1b;">\${cnt.A}</div><div class="sum-lbl">Absent (LOP)</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#9a3412;">\${cnt.HD}</div><div class="sum-lbl">Half Day</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#1e40af;">\${cnt.CL}</div><div class="sum-lbl">Casual Leave</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#854d0e;">\${cnt.SL}</div><div class="sum-lbl">Sick Leave</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#065f46;">\${cnt.EL}</div><div class="sum-lbl">Earned Leave</div></div>
      <div class="sum-cell"><div class="sum-val" style="color:#5b21b6;">\${cnt.H}</div><div class="sum-lbl">Holiday</div></div>
      <div class="sum-cell" style="background:#fff3cd;"><div class="sum-val" style="color:#856404;">\${lopDays}</div><div class="sum-lbl">LOP Days</div></div>
      <div class="sum-cell" style="background:#dcfce7;"><div class="sum-val" style="color:#1e7c4a;">\${totalVisits}</div><div class="sum-lbl">Total Visits</div></div>
      <div class="sum-cell" style="background:#fff3e0;"><div class="sum-val" style="color:#e8611a;">₹\${totalConv.toLocaleString('en-IN')}</div><div class="sum-lbl">Daily Conveyance</div></div>
      <div class="sum-cell" style="background:#eef3fa;"><div class="sum-val" style="color:#1A3C6E;">₹\${totalReimb.toLocaleString('en-IN')}</div><div class="sum-lbl">Total Reimbursable</div></div>
    </div>
  </div>

  <div class="section pg-break" style="margin-top:16px;">
    <div class="section-title">Outstation Travel Log</div>
    <table>
      <thead><tr><th>Trip Dates</th><th>City</th><th>Zone / Class</th><th>Nights</th><th>Travel Mode</th><th>Lodging</th><th>Amount Claimed</th><th>Policy Cap</th><th>Status</th></tr></thead>
      <tbody>\${tripRows}</tbody>
    </table>
    \${empTrips.length>0?\`<div style="text-align:right;margin-top:6px;font-weight:700;font-size:11px;color:#1A3C6E;">Total Outstation Expense: ₹\${outstationTotal.toLocaleString('en-IN')}</div>\`:''}
  </div>

  <div class="section" style="margin-top:16px;background:#eef3fa;border-radius:6px;padding:12px;">
    <div class="section-title">Salary Impact Summary</div>
    <table style="font-size:10px;">
      <tr><td style="color:#555;">Gross Salary (full month)</td><td style="text-align:right;font-weight:500;">₹\${sal.gross.toLocaleString('en-IN')}</td>
          <td style="width:20px;"></td>
          <td style="color:#555;">LOP Days</td><td style="text-align:right;font-weight:500;">\${lopDays} days</td></tr>
      <tr><td style="color:#555;">LOP Deduction (@₹\${Math.round(perDay).toLocaleString('en-IN')}/day)</td><td style="text-align:right;color:#991b1b;font-weight:500;">-₹\${lopDed.toLocaleString('en-IN')}</td>
          <td></td>
          <td style="color:#555;">Daily Conveyance Claimed</td><td style="text-align:right;font-weight:500;">₹\${totalConv.toLocaleString('en-IN')}</td></tr>
      <tr><td style="color:#555;">Gross Payable</td><td style="text-align:right;font-weight:600;color:#1A3C6E;">₹\${grossPay.toLocaleString('en-IN')}</td>
          <td></td>
          <td style="color:#555;">Outstation Expense</td><td style="text-align:right;font-weight:500;">₹\${outstationTotal.toLocaleString('en-IN')}</td></tr>
      <tr style="border-top:1px solid #ccc;"><td style="font-weight:700;color:#1A3C6E;">Total Reimbursable to Employee</td><td style="text-align:right;font-weight:700;color:#e8611a;">₹\${totalReimb.toLocaleString('en-IN')}</td>
          <td></td>
          <td style="font-weight:700;color:#1A3C6E;">Store Visits</td><td style="text-align:right;font-weight:700;">\${totalVisits} / \${(emp.visitTarget||12)*cnt.P} target</td></tr>
    </table>
  </div>

  <div class="footer-sign">
    <div class="sign-box"><div class="sign-line"></div><div class="sign-lbl">Employee Signature</div></div>
    <div class="sign-box"><div class="sign-line"></div><div class="sign-lbl">Reporting Manager</div></div>
    <div class="sign-box"><div class="sign-line"></div><div class="sign-lbl">HR / Management</div></div>
  </div>
  <div class="note">This is a system-generated attendance muster. Happy Hands Global LLP | Generated: \${new Date().toLocaleDateString('en-IN')}</div>
  </body></html>\`;
}



// ══════════════════════════════════════════════════════════════
// KPI & PIP STATE
// ══════════════════════════════════════════════════════════════
let kpiData = JSON.parse(localStorage.getItem('hh3_kpi') || '{}');
let pipData  = JSON.parse(localStorage.getItem('hh3_pip') || '[]');
let kpiFilter = null;
let pipOpenId = null;

function saveKPI()  { try{localStorage.setItem('hh3_kpi', JSON.stringify(kpiData)); }catch(e){} }
function savePIP()  { try{localStorage.setItem('hh3_pip', JSON.stringify(pipData));  }catch(e){} }

// ── KPI Helpers ────────────────────────────────────────────────
const RATINGS = [
  {min:130, id:1, lbl:'Exceptional',          cls:'r1', inc:'18–25%',  bonus:12000},
  {min:110, id:2, lbl:'Exceeds Expectations', cls:'r2', inc:'12–17%',  bonus:8000},
  {min:90,  id:3, lbl:'Meets Expectations',   cls:'r3', inc:'8–11%',   bonus:5000},
  {min:70,  id:4, lbl:'Needs Improvement',    cls:'r4', inc:'3–5%',    bonus:2500},
  {min:0,   id:5, lbl:'Unsatisfactory',       cls:'r5', inc:'Nil',     bonus:0},
];
function getRating(pct) { return RATINGS.find(r => pct >= r.min) || RATINGS[4]; }

function kpiKey(empId, y, m) { return \`\${empId}_\${y}_\${m}\`; }

function getKPI(empId, y, m) {
  const k = kpiKey(empId, y, m);
  const emp = emps.find(e => e.id === empId) || {};
  const att = getAttSummary ? getAttSummary(empId, y, m) : {};
  const presentDays = att.P || 0;
  return kpiData[k] || {
    billedRev: 0,
    revTarget: emp.revTarget || 300000,
    visits: 0,
    visitTarget: (emp.visitTarget || 12) * presentDays,
    newStores: 0,
    newStoresTarget: emp.newStoresTarget || 5,
    collection: 0,
    collectionTarget: 0,
    notes: '',
    locked: false,
  };
}

function getAttSummary(empId, y, m) {
  const days = daysIn(y, m);
  const c = {P:0,A:0,HD:0,H:0,WO:0,CL:0,SL:0,EL:0,unm:0};
  for(let d=1;d<=days;d++){
    const s=att[\`\${empId}_\${y}_\${m}_\${d}\`];
    if(s&&c[s]!==undefined)c[s]++;
    else if(!s){if(new Date(y,m-1,d).getDay()===0)c.WO++;else c.unm++;}
  }
  return c;
}

function calcKPIOvr(kpi) {
  // Weighted overall achievement
  const w = { rev:0.50, vis:0.25, str:0.15, col:0.10 };
  const revPct = kpi.revTarget > 0 ? (kpi.billedRev / kpi.revTarget) * 100 : 0;
  const visPct = kpi.visitTarget > 0 ? (kpi.visits / kpi.visitTarget) * 100 : 100;
  const strPct = kpi.newStoresTarget > 0 ? (kpi.newStores / kpi.newStoresTarget) * 100 : 100;
  const colPct = kpi.collectionTarget > 0 ? (kpi.collection / kpi.collectionTarget) * 100 : 100;
  const overall = revPct*w.rev + visPct*w.vis + strPct*w.str + colPct*w.col;
  return { revPct, visPct, strPct, colPct, overall };
}

function getAnnualPerf(empId, y) {
  const months = [1,2,3,4,5,6,7,8,9,10,11,12];
  const monthly = months.map(m => {
    const k = kpiKey(empId, y, m);
    if (!kpiData[k] || kpiData[k].billedRev === 0) return null;
    return calcKPIOvr(kpiData[k]).overall;
  }).filter(v => v !== null);
  if (!monthly.length) return null;
  return monthly.reduce((a,b) => a+b, 0) / monthly.length;
}

function setKPIFilter(id) {
  kpiFilter = kpiFilter === id ? null : id;
  renderKPI();
}

function updateKPIField(empId, field, val) {
  const k = kpiKey(empId, curYear, curMonth);
  if (!kpiData[k]) kpiData[k] = getKPI(empId, curYear, curMonth);
  kpiData[k][field] = field === 'notes' ? val : (Number(val)||0);
  saveKPI();
}

// ── PIP Helpers ─────────────────────────────────────────────────
function activePIPs() { return pipData.filter(p => p.status === 'active'); }
function empPIPs(empId) { return pipData.filter(p => p.empId === empId); }
function hasPIP(empId) { return activePIPs().some(p => p.empId === empId); }

function openPIPForm(empId) {
  document.getElementById('pip-form-emp').value = empId || (emps[0] ? emps[0].id : '');
  document.getElementById('pip-form-reason').value = '';
  document.getElementById('pip-form-targets').value = '';
  document.getElementById('pip-form-support').value = '';
  const today = new Date().toISOString().slice(0,10);
  const end = new Date(Date.now() + 60*24*60*60*1000).toISOString().slice(0,10);
  document.getElementById('pip-form-start').value = today;
  document.getElementById('pip-form-end').value = end;
  document.getElementById('pip-modal').style.display = 'flex';
}

function closePIPModal() {
  document.getElementById('pip-modal').style.display = 'none';
}

function savePIPForm() {
  const empId   = document.getElementById('pip-form-emp').value;
  const reason  = document.getElementById('pip-form-reason').value.trim();
  const targets = document.getElementById('pip-form-targets').value.trim();
  const support = document.getElementById('pip-form-support').value.trim();
  const start   = document.getElementById('pip-form-start').value;
  const end     = document.getElementById('pip-form-end').value;
  if(!empId||!reason||!targets||!start||!end){ alert('Please fill all required fields.'); return; }
  const pip = {
    id: 'pip_'+Date.now(), empId, reason, targetsText: targets, supportText: support,
    startDate: start, endDate: end, status: 'active',
    progressLogs: [], closureDate:'', closureNotes:'', outcome:'',
  };
  pipData.push(pip);
  savePIP();
  closePIPModal();
  renderPIP();
}

function addPIPLog(pipId) {
  const notes = document.getElementById('log-notes-'+pipId)?.value?.trim();
  if(!notes) return;
  const pip = pipData.find(p => p.id === pipId);
  if(!pip) return;
  pip.progressLogs.push({ date: new Date().toLocaleDateString('en-IN'), notes, by: 'HR' });
  savePIP();
  renderPIP();
}

function closePIP(pipId, outcome) {
  const pip = pipData.find(p => p.id === pipId);
  if(!pip) return;
  const notes = document.getElementById('close-notes-'+pipId)?.value?.trim()||'';
  pip.status  = outcome === 'pass' ? 'closed_pass' : 'closed_fail';
  pip.outcome = outcome === 'pass' ? 'Successful — Employee returned to normal performance track' : 'Unsuccessful — Termination with notice pay as per policy';
  pip.closureDate  = new Date().toLocaleDateString('en-IN');
  pip.closureNotes = notes;
  savePIP();
  renderPIP();
}

function deletePIP(pipId) {
  if(!confirm('Delete this PIP record permanently?')) return;
  pipData = pipData.filter(p => p.id !== pipId);
  savePIP();
  renderPIP();
}

function togglePIP(pipId) {
  pipOpenId = pipOpenId === pipId ? null : pipId;
  renderPIP();
}

// ══════════════════════════════════════════════════════════════
// RENDER KPI
// ══════════════════════════════════════════════════════════════
function renderKPI() {
  const filtered = kpiFilter ? emps.filter(e => e.id === kpiFilter) : emps;

  // Filter chips
  const chips = \`<div class="filter-chips">
    <button class="chip\${!kpiFilter?' active':''}" onclick="setKPIFilter(null)">👥 All Employees</button>
    \${emps.map(e=>\`<button class="chip\${kpiFilter===e.id?' active':''}" onclick="setKPIFilter('\${e.id}')">\${e.name.split(' ')[0]}</button>\`).join('')}
  </div>\`;

  // KPI cards
  const cards = filtered.map(emp => {
    const kpi   = getKPI(emp.id, curYear, curMonth);
    const pcts  = calcKPIOvr(kpi);
    const rat   = getRating(pcts.overall);
    const pip   = hasPIP(emp.id);
    const ini   = emp.name.split(' ').map(n=>n[0]).join('').slice(0,2);
    const col   = pcts.overall >= 110 ? '#1e7c4a' : pcts.overall >= 90 ? '#1A3C6E' : pcts.overall >= 70 ? '#856404' : '#991b1b';
    const barcol= pcts.overall >= 110 ? '#1e7c4a' : pcts.overall >= 90 ? '#2E6DA4' : pcts.overall >= 70 ? '#E8611A' : '#C0392B';

    // Live visits from attendance
    const attS  = getAttSummary(emp.id, curYear, curMonth);
    const liveVisits = (function(){let t=0;const d=daysIn(curYear,curMonth);for(let day=1;day<=d;day++)t+=Number(att[\`\${emp.id}_\${curYear}_\${curMonth}_\${day}_v\`]||0);return t;})();
    const liveVT= (emp.visitTarget||12)*(attS.P||0);
    const visPct2 = liveVT>0 ? Math.min(200,Math.round((liveVisits/liveVT)*100)) : 0;

    const metrics = [
      { lbl:'Billed Revenue', icon:'💰', val: INR(kpi.billedRev), target:\`Target: \${INR(kpi.revTarget)}\`,
        pct: Math.min(200,Math.round(pcts.revPct)), weight:'50% weight',
        input:\`<input type="number" class="input-sm" style="width:120px;" placeholder="₹ Achieved" value="\${kpi.billedRev||''}"
               onchange="updateKPIField('\${emp.id}','billedRev',this.value);renderKPI();">\`
      },
      { lbl:'Store Visits', icon:'🏪', val:\`\${liveVisits} visits\`, target:\`Target: \${liveVT}\`,
        pct: visPct2, weight:'25% weight (auto)',
        input:\`<div style="font-size:11px;color:var(--subtext);">Auto-pulled from attendance</div>\`
      },
      { lbl:'New Stores Added', icon:'➕', val:\`\${kpi.newStores} stores\`, target:\`Target: \${kpi.newStoresTarget}\`,
        pct: Math.min(200,kpi.newStoresTarget>0?Math.round((kpi.newStores/kpi.newStoresTarget)*100):100), weight:'15% weight',
        input:\`<input type="number" class="input-sm" style="width:80px;" placeholder="Count" value="\${kpi.newStores||''}"
               onchange="updateKPIField('\${emp.id}','newStores',this.value);renderKPI();">\`
      },
      { lbl:'Collection (₹)', icon:'🏦', val: INR(kpi.collection), target:\`Target: \${kpi.collectionTarget>0?INR(kpi.collectionTarget):'Set target'}\`,
        pct: kpi.collectionTarget>0?Math.min(200,Math.round((kpi.collection/kpi.collectionTarget)*100)):0, weight:'10% weight',
        input:\`<div style="display:flex;gap:4px;"><input type="number" class="input-sm" style="width:110px;" placeholder="₹ Collected" value="\${kpi.collection||''}"
               onchange="updateKPIField('\${emp.id}','collection',this.value);renderKPI();">
               <input type="number" class="input-sm" style="width:110px;" placeholder="₹ Target" value="\${kpi.collectionTarget||''}"
               onchange="updateKPIField('\${emp.id}','collectionTarget',this.value);renderKPI();"></div>\`
      },
    ];

    const metCols = metrics.map(m => \`<div class="kpi-metric">
      <div class="kpi-metric-lbl">\${m.icon} \${m.lbl}</div>
      <div class="kpi-metric-val">\${m.val}</div>
      <div class="kpi-metric-target">\${m.target}</div>
      <div class="kpi-bar-wrap"><div class="kpi-bar" style="width:\${Math.min(100,m.pct)}%;background:\${m.pct>=100?'#1e7c4a':m.pct>=70?'#E8611A':'#C0392B'};"></div></div>
      <div style="font-size:9px;color:var(--subtext);margin-top:2px;">\${m.pct}% achieved · \${m.weight}</div>
      <div style="margin-top:6px;">\${m.input}</div>
    </div>\`).join('');

    const annPerf = getAnnualPerf(emp.id, curYear);
    const annRat  = annPerf !== null ? getRating(annPerf) : null;

    return \`<div class="kpi-card">
      <div class="kpi-head">
        <div style="display:flex;align-items:center;gap:10px;">
          <div style="width:36px;height:36px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;">\${ini}</div>
          <div>
            <div style="font-weight:700;font-size:14px;">\${emp.name} \${pip?'<span style="background:#e8611a;padding:1px 8px;border-radius:10px;font-size:10px;margin-left:4px;">⚠️ PIP Active</span>':''}</div>
            <div style="font-size:11px;opacity:0.65;">\${GRADES[emp.grade]||emp.grade} · \${emp.territory} · CTC \${INR(emp.ctc)}</div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:12px;">
          <div style="text-align:center;">
            <div class="pct-ring" style="color:\${col};border-color:\${col};">\${Math.round(pcts.overall)}%</div>
            <div style="font-size:9px;color:rgba(255,255,255,0.7);margin-top:2px;">Overall</div>
          </div>
          <div>
            <div class="rating-pill \${rat.cls}">\${rat.lbl}</div>
            <div style="font-size:10px;opacity:0.7;margin-top:3px;">Increment: \${rat.inc} · Bonus: \${rat.bonus>0?INR(rat.bonus):'Statutory only'}</div>
          </div>
        </div>
      </div>
      <div class="kpi-body">\${metCols}</div>
      <div style="padding:10px 14px;background:var(--gray);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;">
        <div style="display:flex;gap:8px;align-items:center;">
          <span style="font-size:11px;color:var(--subtext);">Revenue target:</span>
          <input type="number" class="input-sm" style="width:120px;" placeholder="₹ Monthly target" value="\${kpi.revTarget||300000}"
            onchange="updateKPIField('\${emp.id}','revTarget',this.value);renderKPI();">
          <span style="font-size:11px;color:var(--subtext);">New store target:</span>
          <input type="number" class="input-sm" style="width:70px;" placeholder="Stores" value="\${kpi.newStoresTarget||5}"
            onchange="updateKPIField('\${emp.id}','newStoresTarget',this.value);renderKPI();">
        </div>
        <div style="display:flex;align-items:center;gap:8px;">
          \${annRat ? \`<span style="font-size:11px;color:var(--subtext);">Annual \${curYear}: <b class="rating-pill \${annRat.cls}" style="padding:2px 8px;">\${Math.round(annPerf)}% — \${annRat.lbl}</b></span>\` : ''}
          \${rat.id>=4&&!pip?\`<button class="btn btn-sm" style="background:#fee2e2;border-color:#fca5a5;color:#991b1b;" onclick="setTab('pip');document.getElementById('pip-form-emp').value='\${emp.id}';document.getElementById('pip-modal').style.display='flex';">⚠️ Initiate PIP</button>\`:''}
          <button class="btn btn-sm" onclick="addKPINotes('\${emp.id}')">📝 Notes</button>
        </div>
      </div>
      \${kpi.notes?\`<div style="padding:8px 14px;font-size:11px;color:var(--subtext);border-top:1px solid var(--border);">📝 \${kpi.notes}</div>\`:''}
    </div>\`;
  }).join('');

  // Annual Performance Summary Table
  const annRows = emps.map(emp => {
    const months = [1,2,3,4,5,6,7,8,9,10,11,12];
    const cells  = months.map(m => {
      const k = kpiKey(emp.id, curYear, m);
      if(!kpiData[k]||kpiData[k].billedRev===0) return \`<td style="text-align:center;color:#ccc;">—</td>\`;
      const pct = Math.round(calcKPIOvr(kpiData[k]).overall);
      const rat = getRating(pct);
      return \`<td style="text-align:center;"><span class="rating-pill \${rat.cls}" style="font-size:9px;padding:1px 5px;">\${pct}%</span></td>\`;
    }).join('');
    const annPct = getAnnualPerf(emp.id, curYear);
    const annR   = annPct !== null ? getRating(annPct) : null;
    const pip    = hasPIP(emp.id);
    return \`<tr>
      <td style="font-weight:600;">\${emp.name}\${pip?' <span style="color:var(--orange);font-size:10px;">⚠️ PIP</span>':''}</td>
      \${cells}
      <td style="text-align:center;">\${annR ? \`<span class="rating-pill \${annR.cls}">\${Math.round(annPct)}%</span>\` : '—'}</td>
      <td style="text-align:center;">\${annR ? \`<b>\${annR.inc}</b>\` : '—'}</td>
      <td style="text-align:center;">\${annR ? (annR.bonus>0?INR(annR.bonus):'Statutory') : '—'}</td>
    </tr>\`;
  }).join('');

  const MONTH_ABB = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  document.getElementById('kpi').innerHTML = \`
    <div class="page-hdr">
      <h2>KPI Tracker — \${MONTHS[curMonth-1]} \${curYear}</h2>
      <div style="display:flex;gap:8px;">\${mnav()}</div>
    </div>
    \${chips}
    <div style="background:var(--lamber);border-radius:8px;padding:8px 14px;margin-bottom:14px;font-size:11px;color:var(--amber);display:flex;gap:6px;align-items:center;">
      <i class="ti ti-info-circle"></i>
      <span><b>Weightage:</b> Billed Revenue 50% · Store Visits 25% (auto from attendance) · New Stores 15% · Collection 10%  &nbsp;|&nbsp; <b>Rating triggers:</b> &gt;130% Exceptional · 110–130% Exceeds · 90–110% Meets · 70–90% Needs Improvement · &lt;70% Unsatisfactory → Auto PIP</span>
    </div>
    \${cards}
    <div class="card">
      <div class="card-head"><h3>📊 Annual Performance Summary — \${curYear}</h3></div>
      <div style="overflow-x:auto;">
        <table class="ann-table" style="width:100%;border-collapse:collapse;">
          <thead><tr style="background:var(--gray);">
            <th>Employee</th>
            \${MONTH_ABB.map(m=>\`<th style="text-align:center;width:48px;">\${m}</th>\`).join('')}
            <th style="text-align:center;">Annual Avg</th>
            <th style="text-align:center;">Increment</th>
            <th style="text-align:center;">Diwali Bonus</th>
          </tr></thead>
          <tbody>\${annRows}</tbody>
        </table>
      </div>
    </div>\`;
}

function addKPINotes(empId) {
  const notes = prompt('Add manager notes for this employee this month:', getKPI(empId,curYear,curMonth).notes||'');
  if(notes===null) return;
  updateKPIField(empId,'notes',notes);
  renderKPI();
}

// ══════════════════════════════════════════════════════════════
// RENDER PIP
// ══════════════════════════════════════════════════════════════
function renderPIP() {
  const activePs  = pipData.filter(p => p.status==='active');
  const closedPs  = pipData.filter(p => p.status!=='active');
  const empOpts   = emps.map(e=>\`<option value="\${e.id}">\${e.name} (\${e.grade})</option>\`).join('');

  function pipCard(pip) {
    const emp  = emps.find(e=>e.id===pip.empId);
    const open = pipOpenId === pip.id;
    const statusCls = pip.status==='active'?'active-pip':pip.status==='closed_pass'?'pass-pip':'fail-pip';
    const badgeCls  = pip.status==='active'?'pip-active':pip.status==='closed_pass'?'pip-pass':'pip-fail';
    const badgeTxt  = pip.status==='active'?'🟠 Active':pip.status==='closed_pass'?'✅ Closed — Pass':'❌ Closed — Fail';
    const ini = emp ? emp.name.split(' ').map(n=>n[0]).join('').slice(0,2) : '??';

    const kpi = emp ? getKPI(emp.id, curYear, curMonth) : {};
    const pcts = emp && kpi.billedRev ? calcKPIOvr(kpi) : null;
    const rat  = pcts ? getRating(pcts.overall) : null;

    // Days remaining / elapsed
    const startD = new Date(pip.startDate), endD = new Date(pip.endDate), now = new Date();
    const total  = Math.round((endD-startD)/(1000*60*60*24));
    const elapsed= Math.max(0,Math.round((now-startD)/(1000*60*60*24)));
    const remain = Math.max(0,Math.round((endD-now)/(1000*60*60*24)));
    const progPct= Math.min(100,Math.round((elapsed/total)*100));

    const progressLogs = pip.progressLogs.map(l=>\`<div class="prog-log">
      <div style="display:flex;justify-content:space-between;"><b>\${l.date}</b><span style="color:var(--subtext);">by \${l.by}</span></div>
      <div style="margin-top:3px;">\${l.notes}</div>
    </div>\`).join('');

    const closureSection = pip.status==='active' ? \`<div style="margin-top:14px;padding-top:12px;border-top:1px solid var(--border);">
        <div style="font-size:12px;font-weight:600;color:var(--navy);margin-bottom:8px;">Close PIP</div>
        <textarea id="close-notes-\${pip.id}" class="input-sm" rows="2" style="width:100%;margin-bottom:6px;" placeholder="Closure notes (outcome, employee response, final decision...)"></textarea>
        <div style="display:flex;gap:6px;">
          <button class="btn btn-sm btn-green" onclick="closePIP('\${pip.id}','pass')">✅ Close — PIP Successful (Pass)</button>
          <button class="btn btn-sm btn-del" onclick="closePIP('\${pip.id}','fail')">❌ Close — PIP Failed (Terminate with notice)</button>
        </div>
      </div>\` : \`<div style="margin-top:12px;padding:10px;border-radius:6px;background:\${pip.status==='closed_pass'?'var(--lgreen)':'var(--lred)'};">
        <div style="font-weight:600;font-size:12px;">\${pip.outcome}</div>
        <div style="font-size:11px;color:var(--subtext);margin-top:2px;">Closed on \${pip.closureDate} \${pip.closureNotes?'· '+pip.closureNotes:''}</div>
      </div>\`;

    return \`<div class="pip-card \${statusCls}">
      <div class="pip-head" onclick="togglePIP('\${pip.id}')">
        <div style="display:flex;align-items:center;gap:10px;">
          <div style="width:32px;height:32px;background:var(--lnavy);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:11px;color:var(--navy);">\${ini}</div>
          <div>
            <div style="font-weight:600;font-size:13px;">\${emp ? emp.name : 'Unknown'} <span class="pip-badge \${badgeCls}">\${badgeTxt}</span></div>
            <div style="font-size:11px;color:var(--subtext);">PIP Period: \${pip.startDate} → \${pip.endDate} (\${total} days) · Initiated: \${pip.startDate}</div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:10px;">
          \${pip.status==='active'?\`<div style="text-align:center;"><div style="font-size:11px;font-weight:700;color:var(--orange);">\${remain} days</div><div style="font-size:9px;color:var(--subtext);">remaining</div></div>\`:''}
          \${rat?\`<span class="rating-pill \${rat.cls}" style="font-size:10px;">\${Math.round(pcts.overall)}% this month</span>\`:''}
          <i class="ti ti-chevron-\${open?'up':'down'}" style="font-size:14px;color:var(--subtext);"></i>
        </div>
      </div>
      \${open ? \`<div class="pip-body">
        \${pip.status==='active'?\`<div style="margin-bottom:12px;">
          <div style="font-size:11px;font-weight:600;color:var(--subtext);margin-bottom:4px;">PIP PROGRESS (\${elapsed}/\${total} days — \${progPct}%)</div>
          <div style="background:#eee;border-radius:20px;height:8px;overflow:hidden;">
            <div style="width:\${progPct}%;height:100%;background:\${progPct<50?'var(--green)':progPct<80?'var(--orange)':'var(--red)'};border-radius:20px;"></div>
          </div>
        </div>\`:''}
        <div class="g2" style="margin-bottom:12px;">
          <div>
            <div style="font-size:11px;font-weight:700;color:var(--navy);margin-bottom:6px;">📋 Reason for PIP</div>
            <div style="font-size:12px;color:var(--text);background:var(--lred);border-radius:6px;padding:8px 10px;">\${pip.reason}</div>
            <div style="font-size:11px;font-weight:700;color:var(--navy);margin:10px 0 6px;">🎯 Performance Targets</div>
            <div style="font-size:12px;white-space:pre-line;background:var(--lnavy);border-radius:6px;padding:8px 10px;">\${pip.targetsText}</div>
          </div>
          <div>
            <div style="font-size:11px;font-weight:700;color:var(--navy);margin-bottom:6px;">🤝 Support Provided</div>
            <div style="font-size:12px;white-space:pre-line;background:var(--lgreen);border-radius:6px;padding:8px 10px;">\${pip.supportText||'Not specified'}</div>
            \${emp&&kpi.billedRev?\`<div style="font-size:11px;font-weight:700;color:var(--navy);margin:10px 0 6px;">📊 Current Month KPI</div>
            <div style="background:var(--gray);border-radius:6px;padding:8px 10px;font-size:11px;">
              Revenue: \${INR(kpi.billedRev)} / \${INR(kpi.revTarget)} (\${Math.round(pcts.revPct)}%)
              &nbsp;|&nbsp; Overall: <span class="rating-pill \${rat.cls}" style="padding:1px 8px;">\${Math.round(pcts.overall)}% — \${rat.lbl}</span>
            </div>\`:''}
          </div>
        </div>
        <div style="font-size:11px;font-weight:700;color:var(--navy);margin-bottom:8px;">📅 Progress Log</div>
        \${progressLogs||\`<div style="color:var(--subtext);font-size:11px;font-style:italic;">No progress logs yet.</div>\`}
        \${pip.status==='active'?\`<div style="display:flex;gap:6px;margin-top:8px;">
          <input type="text" id="log-notes-\${pip.id}" class="input-sm" style="flex:1;" placeholder="Add progress note (coaching session, visit accompaniment, target update...)">
          <button class="btn btn-sm btn-primary" onclick="addPIPLog('\${pip.id}')">+ Add Log</button>
        </div>\`:''}
        \${closureSection}
        <div style="margin-top:10px;text-align:right;">
          <button class="btn btn-sm btn-del" onclick="deletePIP('\${pip.id}')"><i class="ti ti-trash"></i> Delete Record</button>
        </div>
      </div>\` : ''}
    </div>\`;
  }

  document.getElementById('pip').innerHTML = \`
    <div class="page-hdr">
      <h2>Performance Improvement Plan (PIP)</h2>
      <button class="btn btn-orange" onclick="openPIPForm()"><i class="ti ti-plus"></i> Initiate New PIP</button>
    </div>
    <div style="background:var(--lnavy);border-radius:8px;padding:10px 14px;margin-bottom:16px;font-size:11px;color:var(--navy);display:flex;gap:10px;align-items:flex-start;">
      <i class="ti ti-info-circle" style="font-size:14px;flex-shrink:0;margin-top:1px;"></i>
      <span><b>HR Policy:</b> PIP is initiated when an employee is rated Needs Improvement (Rating 4) or Unsatisfactory (Rating 5).
      Duration: <b>60 days</b>. Document must specify target metrics, support provided, and review dates.
      On success: employee returns to normal performance track.
      On failure: termination with one month's notice pay.</span>
    </div>
    <div class="g3" style="margin-bottom:16px;">
      <div class="stat"><div class="stat-lbl">Active PIPs</div><div class="stat-val" style="color:var(--orange);">\${activePs.length}</div><div class="stat-sub">Currently running</div></div>
      <div class="stat"><div class="stat-lbl">Closed — Pass</div><div class="stat-val" style="color:var(--green);">\${closedPs.filter(p=>p.status==='closed_pass').length}</div><div class="stat-sub">Successful outcomes</div></div>
      <div class="stat"><div class="stat-lbl">Closed — Fail</div><div class="stat-val" style="color:var(--red);">\${closedPs.filter(p=>p.status==='closed_fail').length}</div><div class="stat-sub">Terminated / exited</div></div>
    </div>
    \${activePs.length?\`<h3 style="font-size:14px;font-weight:600;color:var(--navy);margin-bottom:10px;">Active PIPs</h3>\${activePs.map(pipCard).join('')}\`:'<div style="text-align:center;padding:30px;color:var(--subtext);background:#fff;border-radius:12px;border:1px solid var(--border);"><i class="ti ti-circle-check" style="font-size:32px;display:block;margin-bottom:8px;color:var(--green);opacity:0.5;"></i>No active PIPs — all employees are meeting expectations.</div>'}
    \${closedPs.length?\`<h3 style="font-size:14px;font-weight:600;color:var(--navy);margin:16px 0 10px;">Closed PIPs (History)</h3>\${closedPs.map(pipCard).join('')}\`:''}

    <!-- PIP Form Modal -->
    <div id="pip-modal" class="modal-bg" style="display:none;" onclick="if(event.target===this)closePIPModal()">
      <div class="modal" style="width:580px;">
        <div class="modal-head"><h3>Initiate Performance Improvement Plan</h3>
          <button class="btn btn-sm" style="color:#fff;border-color:rgba(255,255,255,0.3);" onclick="closePIPModal()"><i class="ti ti-x"></i></button>
        </div>
        <div class="modal-body">
          <div style="background:var(--lred);border-radius:6px;padding:8px 12px;margin-bottom:12px;font-size:11px;color:var(--red);">
            ⚠️ Issuing a PIP is a formal HR action. Ensure the employee has been verbally counselled before this step.
          </div>
          <div class="form-row">
            <div class="form-group"><label>Employee *</label>
              <select id="pip-form-emp">\${empOpts}</select>
            </div>
            <div class="form-group"><label>Rating Trigger</label>
              <select id="pip-form-trigger">
                <option value="r4">Rating 4 — Needs Improvement (70–90% target)</option>
                <option value="r5">Rating 5 — Unsatisfactory (&lt;70% target)</option>
                <option value="conduct">Conduct / Behaviour Issue</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group"><label>PIP Start Date *</label><input id="pip-form-start" type="date"></div>
            <div class="form-group"><label>PIP End Date * <span style="font-size:10px;color:var(--subtext);">(Policy: 60 days)</span></label><input id="pip-form-end" type="date"></div>
          </div>
          <div class="form-group" style="margin-bottom:10px;">
            <label>Reason for PIP *</label>
            <textarea id="pip-form-reason" class="input-sm" rows="2" style="width:100%;" placeholder="e.g. Revenue achievement below 65% for 2 consecutive months. Store visits averaging 6/day vs target of 12/day."></textarea>
          </div>
          <div class="form-group" style="margin-bottom:10px;">
            <label>Performance Targets During PIP * <span style="font-size:10px;color:var(--subtext);">(specific, measurable)</span></label>
            <textarea id="pip-form-targets" class="input-sm" rows="4" style="width:100%;" placeholder="1. Billed Revenue: Minimum ₹2,10,000/month (70% of ₹3,00,000 target)
2. Daily Store Visits: Minimum 10 visits/day
3. New Store Addition: Minimum 3 new stores/month
4. Attendance: No unauthorised absences"></textarea>
          </div>
          <div class="form-group" style="margin-bottom:10px;">
            <label>Support to be Provided <span style="font-size:10px;color:var(--subtext);">(company's commitment)</span></label>
            <textarea id="pip-form-support" class="input-sm" rows="3" style="width:100%;" placeholder="1. Weekly 1:1 coaching with Reporting Manager (every Monday)
2. Joint market visits by NSM (2 per month)
3. Product demo refresher training (Week 1)
4. Access to top retailer contact list for territory"></textarea>
          </div>
        </div>
        <div class="modal-foot">
          <button class="btn" onclick="closePIPModal()">Cancel</button>
          <button class="btn btn-orange" onclick="savePIPForm()"><i class="ti ti-alert-triangle"></i> Issue PIP</button>
        </div>
      </div>
    </div>\`;
}

// ── INIT ─────────────────────────────────────────────────────
trips=JSON.parse(localStorage.getItem('hh3_trips')||'{}');
kpiData=JSON.parse(localStorage.getItem('hh3_kpi')||'{}');
pipData=JSON.parse(localStorage.getItem('hh3_pip')||'[]');
document.getElementById('hdr-date').textContent=new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'});
renderDash();
`;
export default HR_SCRIPT;
